<template xmlns="http://www.w3.org/1999/html">
  <div class="privacy">
    <p class="title">隐私信息保护政策</p>
    <p>发布时间：2020年1月25日<br/>
    生效时间：2020年1月25日<br/>
    更新时间：2026年4月30日</p>
    <p class="level1">我们非常重视您的隐私权</p>
    <p>
      广州心与潮信息科技有限公司（以下简称：“心潮科技”）尊重并保护所有使用小睡眠移动客户端的用户（以下称为“您”）个人隐私与信息安全。鉴于此，心潮科技制定《小睡眠隐私信息保护政策》（以下称为“本政策”）与您确认关于您在使用小睡眠移动客户端期间，心潮科技将收集、存储、使用、管理和保护您的个人信息的相关事宜。在使用小睡眠移动客户端前，请您务必仔细阅读并透彻理解本政策，<span class="strong">特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。</span>在此过程中，如果您有任何疑问、意见或建议，您可通过心潮科技提供的各种联系方式与我们取得联系，我们会尽快为您作出解答。
    </p>
    <p class="level2">一、心潮科技公司如何收集您的个人信息</p>
    <p>您在使用我们的产品或服务时，我们需要/可能需要收集和使用您的相关个人信息；用以向您提供服务、优化我们的服务以及保障您的账户安全。</p>

    <p class="level3 strong">（一）小睡眠 App 所收集的信息</p>
    <p class="level4 strong">1. 服务内容展示/浏览/播放/下载功能</p>
    <p><span class="strong">收集目的：</span>为保障您正常使用我们的 <span class="strong">服务内容展示/浏览/播放/下载功能，</span>维护我们服务的正常运行，了解产品对不同硬件设备适配性、确保操作环境安全、识别账号异常状态用途。</p>
    <p><span class="strong">收集方式及范围：</span>我们根据合法、正当、必要的原则，收集实现产品功能所必要的信息。您在软件安装或使用中同意授权隐私政策之后，收集您的<span class="strong">设备硬件序列号、设备型号、操作系统、唯一设备标识符、IP地址、操作日志、MAC地址、Android ID、匿名设备标识符(OAID)、设备运行进程信息、应用程序安装列表信息、获取应用安装列表、获取设备传感器、蓝牙地址、读取设备IP。</span></p>
    <p class="strong">其中设备运行进程信息、应用程序安装列表信息仅在设备本地使用，用于防止恶意程序和反作弊，并且不会上传服务器。</p>
    <p>我方客户端收集您的设备信息的频次与时机是 <span class="strong">仅在您启动客户端时执行一次，且当客户端处于后台运行状态时，不会再次收集您的设备信息。</span></p>
    <p>我们收集这些信息是为了向您提供我们最核心的服务内容展示/播放/下载服务，如您拒绝提供上述信息或权限将可能导致您无法使用我们的产品与服务。请您知悉，单独的设备信息、日志信息无法识别您的身份信息。</p>
    <p class="level4 strong">2. 日志信息</p>
    <p>当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存，用于帮助我们优化产品服务。包括您的搜索和浏览记录、关注、播放记录、访问量、播放时长、IP地址、WiFi网络、使用的语言、访问日期和时间。</p>
    <p class="level4 strong">3. 创建账号功能</p>
    <p>当您在我方客户端创建账号时，我们会收集由您主动提供给我们的一些单独或者结合识别您实名身份的信息，包括： <span class="strong">手机号码</span>、用户名。我们收集这些信息是用以完成注册程序、为您持续稳定提供专属于注册用户的产品或服务，并保护您的账号安全。您应知悉，手机号码和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是为了满足相关法律法规的要求，如您拒绝提供可能导致您无法使用我们的此功能，请您谨慎考虑后再提供。</p>
    <p class="level4 strong">4. 第三方账号信息</p>
    您使用第三方平台的账号（<span class="strong">微信账号、微博账号、QQ账号、通过Apple登录、手机系统账号、Facebook、Google</span>）登录时，如果您决定绑定小睡眠账号，经过您的账号绑定授权，第三方平台会同步一部分信息给我方，如头像、昵称或ID。我们收集这些信息是用于为您提供账号登录服务以及保障您的账号安全，防范安全风险。如您拒绝授权此类信息的，您将无法使用第三方 平台的账号登录我们平台，但不影响我们为您提供的其他产品和服务的正常使用。
    <p class="level4 strong">5. 基本资料维护&身份验证</p>
    <p>【基本信息维护】您在使用我方客户端时，为维护您的基本资料，改善您的服务体验，需要您选择填写及/或完善服务必要的信息，可能包括您的性别、所在地、头像、昵称、生日。如您不提供这些信息，并不影响您对我方客户端核心功能使用。</p>
    <p>【身份验证】如果您的账号遗失，我们将提供两种方式验证您的身份，如手机身份验证，或通过客服方式找回，在此过程中需您提供一些信息以验证您的身份。<span class="strong">在找回账号时，我方可能需要您提供经常登录设备、经常收听内容 、注册时间，必要时需要提供支付订单凭证。</span></p>
    <p class="level4 strong">6. 上传或发布信息功能</p>
    如果您选择发送评论或在评论区留言、发帖的服务，除创建和注册账号外，您可能还需要提供<span class="strong">必要的身份信息</span>。对于经常性或批量上传垃圾广告、或违规内容的用户，为了确保内容安全、避免可疑的上传账号对我方平台用户和受众的打扰，净化网络空间，我方客户端可能会通过产品功能，额外要求前述用户 <span class="strong">绑定手机号码</span>，如用户拒绝提供，我方有权关闭该用户上传需求。您发布的信息中可能包含他人的个人信息，请您务必 取得他人的合法授权，避免非法泄露他人的个人信息。如您不同意我们收集上述信息，您将无法使用我们的信息发布功能，但不影响您使用我们为您提供的其他功能和服务。
    <p class="level4 strong">7. 消息通知与定向推送</p>
    <p>基于您向我们提供的信息、我们可能收集的信息及我们通过间接方式收集到的您的信息，<b>例如您的浏览、搜索及播放记录、设备信息、位置信息、订单信息，我们可能会基于上述一项或几项信息的结合，进行推荐算法建模、程序化广告推荐算法建模、用户行为分析及用户画像，用于提取您的浏览、搜索偏好、行为习惯、位置信息相关特征，以便向您提供更契合您需求的页面展示和推荐个性化内容。</b></p>
<p>我们会根据您的个人信息（例如<b>浏览、搜索及播放记录、设备信息、位置信息、订单信息</b>），通过“消息通知”的方式向您提供或推广我们的商品和服务。</p>
同时，我们努力保障您的浏览体验，为您提供相应的退出机制，您可通过“<b>我的-系统设置-个性化内容推荐</b>”自主选择关闭定向推送功能。关闭后，您接收到的消息推送通知的相关性会降低。
    <p class="level4 strong">8. 记录睡眠功能</p>
    您在使用作息梦话 - 记录睡眠功能时，我们会收集您的设备电池信息，用于运行记录睡眠算法功能，检测您的设备电量偏低时，记录睡眠算法会自动停止，以节省您的设备耗电。我们还会在征得您的同意后，申请 <span class="strong">允许录音权限、允许存储权限，用于分析您的睡眠质量以及检测梦话、呼噜声（音频文件仅保存在设备本地，不会上传至服务器），以提供给您可以在设备上查看睡眠报告的服务。</span>
    <p class="level4 strong">9. 宁静空间功能</p>
    您在使用宁静空间功能时，我们会在征得您的同意后，申请<span class="strong">允许录音权限，用于运行周围环境噪音分析算法（仅用于算法分析，不会收集、保存您的音频信息），以提供给您可以屏蔽周围噪音的服务。</span>
    <p class="level4 strong">10. 心跳实验功能</p>
    您在使用心跳实验功能时，我们会在征得您的同意后，申请<span class="strong">允许相机权限，用于运行心率变化分析算法（仅用于算法分析，不会收集、保存您的心率信息），以提供给您符合当下心情的内容推荐服务。</span>
    <p class="level4 strong">11. 您参加运营和互动活动</p>
    若您参加我方客户端的运营和互动活动，如兑换礼品、抽奖、参加竞猜、答题、问卷调查时，可能需要您主动提交有关信息。<span class="strong">例如对特定活动所领取的红包进行提现、奖品兑现和向税务机构完税，您可能需要提交身份证信息。</span>若奖品或者活动礼品需要寄送，您还需要提供地址信息。<br/>
    当你在小睡眠App与朋友之间互动交流时，为保持服务的稳定性，我们可能会收集你的互动信息。基于活动需要，我们会展示你的小睡眠昵称、头像，及是否参与睡眠挑战等公开信息。如你在分享内容，与其他用户产生互动时，我们会记录你们之间的互动情况。在你分享或接收被分享的信息，参与活动的情况下，基于活动功能需要，小睡眠App可能需要读取你的手机相册，我们会申请获取你的相册及存储权限，在你开启相关权限后，我们会访问你的相册，以便于你分享或者接收被分享的图片。
    <p class="level4 strong">12. 为您提供会员、声音卡、宝宝卡或订阅服务</p>
    为完成会员、声音卡、宝宝卡费用支付，我们会记录您的支付方式和资金账号，以实现原路径退款、活动红包提现、解除连续订阅服务、售后服务。我们会根据您选择的支付方式把您的订单支付相关信息、订单安全相关设备信息及其他反洗钱法律要求的必要信息通过在应用程序中嵌入的支付宝以及其他第三方支付的软件工具开发包（SDK）的方式与支付宝公司或其他第三方支付公司共享。同时，我们会记录并向您展示您账号的订单信息，包括购买会员、声音卡、充值睡贝的信息。
    <p class="level4 strong">13. 客户服务及争议处理</p>
    <p>为向您提供客户服务，我们会记录您提供的联系方式和通信/通话记录和内容，用于与您联系和帮助您解决问题，或记录相关问题的处理方案及结果。</p>
    <p>为确认交易状态及为您提供会员VIP售后与争议解决服务，我们会通过您基于交易所选择的支付机构、支付方式收集与交易相关的<span class="strong">您的交易、支付信息（如iOS端的IAP支付的交易凭证和收费凭证）。</span></p>
    <p class="level4 strong">14. 安全保障功能</p>
    我们需要收集您的一些信息来保障您使用我们的产品或服务时的账号与系统安全，并协助提升我们的产品服务的安全性和可靠性，以防产生任何危害用户、心潮科技、社会的行为，包括您的如下<span class="strong">个人信息：个人常用设备信息（包含：硬件型号、设备MAC地址、IMEI、IMSI）、 登录IP地址、产品版本号、浏览记录、服务故障信息，以及个人敏感信息：手机号码、交易信息。</span>我们会根据上述信息来综合判断您账号及交易风险、进行身份验证、客户服务、检测及防范安全事件、诈骗监测、存档和备份用途，并依法采取必要的记录、审计、分析、处置措施。一旦我们检测出存在或疑似存在账号安全风险时，我们会使用相关信息进行安全验证与风险排除，确保我们向您提供的产品和服务的安全性，以用来保障您的权益不受侵害。同时，当发生账号或系统安全问题时，我们会收集这些信息来优化我们的产品和服务。
    <p class="level4 strong">15. 闹钟唤醒功能</p>
    您在使用闹钟唤醒功能时，我们会通过安卓系统发送⼴播唤醒APP自启动与关联启动的方式，以保障在被杀掉进程或手机重启的情况下，仍然可以实现闹钟唤醒的服务体验。如若您不需要使用该功能，可以在手机设置 - 应用管理 - 应用权限中，关闭小睡眠的自启动与关联启动的权限。
    <p class="level4 strong">16. 粘贴复制功能</p>
    为了便于您分享已复制的内容，我们需要请求访问粘贴板（剪贴板、剪切板）权限，获取您的粘贴板（剪贴板、剪切板）信息，读取其中包含的链接、内容，从而保证分享等功能的实现。当您在进行文字聊天、发表评论、内容复制的场景下，当您选择主动复制、粘贴相关文字时，我们会调用您的粘贴板（剪贴板、剪切板），但我们并不会存储您粘贴板（剪贴板、剪切板）的其他信息。
    <p class="level4 strong">17. 传感器应用场景</p>
    为了 满足广告功能的业务需求，为您展示创新互动广告时（如摇动、扭动、扭转设备），我们需要调用您的加速度传感器、重力传感器、陀螺仪传感器、旋转矢量传感器、光线传感器，调用设备传感器，以识别判断设备状态，从而判断用户是否参与交互广告。
    <p class="level4 strong">18. 社区发布梦话服务</p>
    您有权将“梦话/呼噜/神秘音”（以下简称“梦话”）内容上传或提供至平台，且您理解并确认：

    <br/><br/>（1）您发布的“梦话”内容享有合法权益（包括但不限于著作权、邻接权、肖像权、姓名权以及其他相关权利），是该内容的权利人或已获得权利人的合法授权，不会侵犯任何第三方的合法权益；并确认您拥有合法充分的权利签署、履行本协议。

    <br/><br/>（2）您上传的“梦话”内容不含违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德已经侮辱、诽谤、黄色、暴力内容；不包含虚构事实、隐瞒真相以误导、欺骗他人内容；不包含广告信息及垃圾信息；也不包含任何损坏文档、病毒、蠕虫、木马或其他类似损害程序代码的内容。

    <br/><br/>（3） 在您使用心潮科技提供的技术服务时，您的“梦话”内容可能会经过平台编码或译码，也可能会与其他用户的“梦话”内容进行打包推广或开展联合活动，但心潮科技保证不会破坏您“梦话”内容的原意，也不会对您的“梦话”内容进行实质性修改。

    <br/><br/>（4） 即便您上传了“梦话”内容，心潮科技仍有权根据“梦话”内容的具体情况、政策形势及自身判断，不将该“梦话”内容对用户公布或向用户提供播放及下载服务。在使用您的“梦话”内容过程中，心潮科技也有权根据实际情况，暂停对您的“梦话”内容提供播放及下载服务。

    <br/><br/>（5） “梦话”内容在平台的曝光量、播放量、下载量等传播效果，通常与其实际内容、用户喜好等不同因素相关，不同的“梦话”内容在平台可能会呈现不同的传播效果，该效果不由平台决定或保证。

    <br/><br/>（6）出于某些原因（如您违反合法约定、或心潮科技收到关于“声音”内容的举报、版权纠纷等），心潮科技有权进行独立判断、在不事先通知您的情况下对相关“梦话”内容进行删除、屏蔽或断开链接等，并采取包括但不限于对您的平台账号权限进行限权、部分限权或停止服务等措施，您亦有权反通知心潮科技进行举证。

    <br/><br/>（7）您完全理解并同意，除本协议另有约定或双方另行签署书面协议外，心潮科技无须就您上传、发布或发表的任何内容支付费用。

    <br/><br/>（8）心潮科技尊重知识产权并注重保护您享有的各项权利。您在“社区”模块发布（上传、分享）“梦话”内容和授权心潮科技的行为不会对您就这些“梦话”内容所享有的知识产权产生任何不良影响。您在提供“梦话”内容时即授予心潮科技及其用户一项全球性的授权许可，允许心潮科技在心潮科技产品中使用、传播、复制、修改、再许可、翻译、创建衍生作品、宣传推广、表演及展示此等内容，并提供给其他用户分享、收藏、下载、收听或以其他方式获得或传播您提供的“梦话”内容。您将前述“梦话”内容上传后，心潮科技有权按照前述约定在心潮科技产品中传播、分享、使用你上传的内容，除非您与心潮科技另行有书面约定或您书面通知心潮科技
    
    <p class="level4 strong">19. 社区发布梦境服务</p>
    您有权将“梦境”内容上传或提供至平台，且您理解并确认：
    <br/><br/>（1）我们重视用户的隐私权，并将采取一切必要的措施来保护您的个人信息。在发布梦境的过程中，收集和使用您的个人信息时，我们将遵守相关的法律法规，不会将您的信息用于任何未经您授权的用途。您在发梦境前可以选择私密或公开在社区，若是选择私密，则该梦境仅自己可见；若是选择公开，则该梦境将会被公开在社区，所有人可见，公开梦境的行为由您主动发起，其中包含的个人信息暴露的后果，也将由您自主承担。

    <br/><br/>（2）您发布的“梦境”内容不含违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德已经侮辱、诽谤、黄色、暴力内容；不包含虚构事实、隐瞒真相以误导、欺骗他人内容；不包含广告信息及垃圾信息；也不包含任何损坏文档、病毒、蠕虫、木马或其他类似损害程序代码的内容。

    <br/><br/>（3） 在您使用心潮科技提供的技术服务时，您的“梦境”内容可能会经过平台编码或译码，也可能会与其他用户的“梦境”内容进行打包推广或开展联合活动，但心潮科技保证不会破坏您“梦境”内容的原意，也不会对您的“梦境”内容进行实质性修改。

    <br/><br/>（4） 即便您发布了“梦境”内容，心潮科技仍有权根据“梦境”内容的具体情况、政策形势及自身判断，不将该“梦境”内容对用户公布。在使用您的“梦境”内容过程中，心潮科技也有权根据实际情况，暂停对您的“梦境”内容提供展示。

    <br/><br/>（5） “梦境”内容在平台的曝光量传播效果，通常与其实际内容、用户喜好等不同因素相关，不同的“梦境”内容在平台可能会呈现不同的传播效果，该效果不由平台决定或保证。

    <br/><br/>（6）出于某些原因（如您违反合法约定、或心潮科技收到关于“梦境”内容的举报），心潮科技有权进行独立判断、在不事先通知您的情况下对相关“梦境”内容进行删除、屏蔽或断开链接等，并采取包括但不限于对您的平台账号权限进行限权、部分限权或停止服务等措施，您亦有权反通知心潮科技进行举证。

    <br/><br/>（7）您完全理解并同意，除本协议另有约定或双方另行签署书面协议外，心潮科技无须就您上传、发布或发表的任何内容支付费用。

    <br/><br/>（8）心潮科技尊重知识产权并注重保护您享有的各项权利。您在“社区”模块发布（上传、分享）“梦境”内容和授权心潮科技的行为不会对您就这些“梦境”内容所享有的知识产权产生任何不良影响。您在提供“梦境”内容时即授予心潮科技及其用户一项全球性的授权许可，允许心潮科技在心潮科技产品中使用、传播、复制、修改、再许可、翻译、创建衍生作品、宣传推广、表演及展示此等内容，并提供给其他用户分享、收藏，或以其他方式获得或传播您提供的“梦境”内容。您将前述“梦境”内容上传后，心潮科技有权按照前述约定在心潮科技产品中传播、分享、使用你上传的内容，除非您与心潮科技另行有书面约定或您书面通知心潮科技。

    <p class="level4 strong">20. 深睡AI服务</p>
    您有权使用深睡AI服务，且您理解并确认：

    <br/><br/>（1）我们重视用户个人信息的保护。在使用本软件及相关服务的过程中，您可能需要提供您的个人信息，我们将遵守相关的法律法规，不会将您的信息用于任何未经您授权的用途。请您务必注意，在使用服务过程中不要上传与您个人身份相关的内容，引发的相关风险由您自行承担。

    <br/><br/>（2）如您为未成年人，需要在征得法定监护人的同意后方能使用本服务，且在使用过程中应严格遵守《全国青少年网络文明公约》。监护人应当合理引导和约束未成年人使用本产品，帮助养成良好上网习惯，避免过度依赖或沉迷。 如您对您所监护的儿童的个人信息有疑问，请通过第九章节中的联系方式与我们联系。

    <br/><br/>（3）深睡AI服务生成的内容仅供参考，不得作为专业建议或用于商业用途。深睡AI不提供任何诊断、治疗或紧急医疗服务。若您需要医疗诊断等专业意见，必须咨询医生相关专业人士，并在专业人士的指导下作出决策。您根据输出的内容所作出的任何判断或者据此作出的后续相关操作行为，所带来的后果和责任均由您自行承担，包括因对输出的内容的真实性、准确性、可靠性、不侵权或满足特定目的的依赖而产生的风险，以及将输出内容用于商业用途而产生的风险。您应科学理性认识和依法使用生成式人工智能技术。

    <br/><br/>（4）深睡AI有权对生成的文本、图片、音频、视频等内容添加人工智能生成标识，包括在生成、合成内容或者交互场景界面中添加用户可明显感知的显式标识，以及在生成、合成内容的文件元数据中添加隐式标识（合称“AI标识”）您不得利用基于生成式人工智能等新技术和新应用制作、发布、传播虚假、不实、侵权等违反法律法规的信息。您不得恶意删除、篡改、伪造或隐匿上述标识，亦不得利用深睡AI服务制作、发布、传播虚假、不实、侵权等违法信息。您在发布或传播利用生成式人工智能生成的信息时，应当以显著方式予以标识或提示。

    <br/><br/>（5）您承诺严格遵守《网络安全法》《互联网信息服务管理办法》《网络信息内容生态治理规定》《生成式人工智能服务管理暂行办法》《人工智能生成合成内容标识办法》等相关法律法规，不得输入或输出含有违反国家法律、危害国家安全、破坏社会稳定、违背公序良俗，以及侮辱、诽谤、淫秽、暴力等违法信息的内容，不得包含虚假或误导性信息、广告垃圾信息，也不得上传含有病毒、木马等恶意代码的程序。

    <br/><br/>（6）出于某些原因（如您违反合法约定、版权纠纷等），心潮科技有权进行独立判断、在不事先通知您的情况下删除相关内容、警示提醒等处置措施，并采取包括但不限于对您的平台账号权限进行限权、部分限权或停止服务等措施，您亦有权反通知心潮科技进行举证。

    <br/><br/>（7）为持续改进服务质量，经严格去标识化且无法识别特定个人前提下，我们可能将收集的输入及对应输出用于模型训练和服务优化。如您不希望您的数据用于模型训练，可联系我们的客服人员关闭相关授权，但请注意这可能会影响您继续使用深睡AI服务。

    <br/><br/>（8）如果您发现本软件及相关服务输出的内容或返回的处理结果不合理、有瑕疵或其他问题，欢迎并感谢您随时通过第九章节中的联系方式与我们联系。

    <br/><br/>（9）心潮科技尊重知识产权并注重保护您享有的各项权利。您承诺所提供的输入内容均为您享有合法知识产权或已获得权利人充分授权的材料，不存在任何违反适用的法律法规、侵犯他人合法权益（包括但不限于著作权、专利权、商标权等知识产权及人格权、个人信息权益等）的内容。在使用过程中，输入内容的知识产权归属于您或者依法享有这些知识产权的权利人。我们不对输出内容主张所有权，但输入和/或输出本身若包含我方享有知识产权的内容，相关权利仍归我方所有，不因包含于输出而改变权属关系。
        





    <p class="level3">（二）第三方 SDK 所收集的信息</p>
    <span class="strong">您授权同意</span>我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私信息保护政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到为其履行职责所需信息，且不得将此信息用于其他任何目的。
    <p>我们的产品以集成 SDK 的方式，实现如下服务类型：</p>
    <p class="level4 strong">1. 数据统计、数据分析服务</p>
    <p class="level4 strong">（1）友盟+SDK（com.umeng）</p>
    <p><span class="strong">使用目的：</span>我们的产品集成友盟+移动统计SDK进行APP数据统计分析，通过采集唯一设备识别码、获取设备硬件序列号（如<span>IMEI、Android ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID 信息</span>）对用户进行唯一标识，以便进行诸如用户新增等数据统计。在特殊情况下（如用户使用平板设备或电视盒子时），无法通过唯一设备识别码标识设备，我们会将设备MAC地址作为用户的唯一标识，以便正常提供统计分析服务。统计分析服务具备基础的反作弊功能，通过获取用户位置信息及IP地址，剔除作弊设备，同时矫正用户的地域分布数据，提高报表数据的准确性。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>友盟同欣（北京）科技有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>友盟+移动统计SDK采集唯一设备识别码、获取设备硬件序列号（如IMEI、Android ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID 信息）、位置信息、网络信息、获取应用列表</p>
    <p><span class="strong">隐私政策链接：</span>https://www.umeng.com/page/policy</p>
    <p class="strong">个人信息类权限使用详情：</p>

    

    <p style="text-indent:2em">a. 读取手机状态数据<br/>
&lt;uses-permission android:name="android.permission.READ_PHONE_STATE" /&gt;<br/>
该权限用于获取设备识别码、序列号 IMEI，通过 IMEI 对用户进行唯一标识，以便提供服务。</p>
    <p style="text-indent:2em">b. 应用访问地理位置信息<br/>
&lt;uses-permission android:name="android.permission.ACCESS_FINE_LOCATION" /&gt;<br/>
&lt;uses-permission android:name="android.permission.ACCESS_COARSE_LOCATION" /&gt;<br/>
该权限用于获取位置信息，为开发者提供反舞弊功能，剔除作弊设备；同时校正用户的地域分布数据，使报表数据更加准确。</p>
    <p style="text-indent:2em">c. 读取手机内存数据<br/>
&lt;uses-permission android:name="android.permission.WRITE_EXTERNAL_STORAGE" /&gt;<br/>
&lt;uses-permission android:name="android.permission.READ_EXTERNAL_STORAGE" /&gt;<br/>
该权限用于保持设备相关信息，以确保设备唯一标识的准确性，以便精确向目标设备推送消息。在不同App间分享大图或多图文件时使用 。</p>
    <p class="level4 strong">（2）日志服务（SLS）SDK</p>
    <p><span class="strong">使用目的：</span>我们的产品集成阿里云数据分析 SDK，用于提供统计分析服务。阿里云数据分析 SDK，通过采集唯一设备识别码 IMEI、IMSI 信息，对用户进行唯一标识，以便提供数据管理同步、统计分析的功能服务。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>阿里云计算有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。获取设备硬件序列号、获取Android ID、获取 MAC 地址。</p>
    <p><span class="strong">隐私政策链接：</span>https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112131013_69952.html</p>
    <p class="strong">个人信息类权限使用详情：</p>

    <table>
      <thead>
        <tr>
          <th>系统</th>
          <th>权限内容</th>
          <th>使用目的</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>安卓</td>
          <td>INTERNET</td>
          <td>用于获取网络访问权限</td>
        </tr>
        <tr>
          <td>安卓</td>
          <td>ACCESS_NETWORK_STATE</td>
          <td>用于获取设备网络状态信息</td>
        </tr>
        <tr>
          <td>iOS</td>
          <td>NSLocalNetworkUsageDescription</td>
          <td>获取局域网内设备连通性，用于发现设备牧场、群控等风险</td>
        </tr>
      </tbody>
    </table>


    <p class="level4 strong">2. 广告展示服务</p>
    <p class="strong">我们的产品集成优量汇 SDK、穿山甲 SDK、京准通 SDK、蒂烨SDK、MMA 中国广告监测通用SDK、创智汇聚 SDK、快手联盟 SDK、倍孜AdScope SDK Android，提供展示开屏广告、信息流广告、激励视频广告。需要读取您的设备唯一识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、读取OAID、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表，用于分析您使用我们的服务情况、优化广告投放、读取特定类型传感器列表、读取设备IP</p>

    <p class="level4 strong">（1）优量汇SDK</p>

    <p><span class="strong">使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>深圳市腾讯计算机系统有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>
      <p style="text-indent:2em">a. 设备信息：唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息；无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址；设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）；设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）。获取设备硬件序列号、获取Android ID；设备制造商、品牌、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、IP地址、时区、网络类型、运营商、磁力、加速度、重力、陀螺仪传感器、设备名称、系统启动时间、系统语言、磁盘空间、设备姿态、压力、加速度传感器等基础信息、读取OAID、读取特定类型传感器列表</p>
      <p style="text-indent:2em">b. 应用信息：获取运行中进程信息、获取应用安装列表</p>
      <p style="text-indent:2em">c. 位置信息：精确位置信息、粗略位置信息</p>
    </p>
    <p><span class="strong">隐私政策链接：</span>https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983</p>

    <p class="strong">个人信息类权限使用详情：</p>

    
    <table>
      <thead>
        <th>权限</th>
        <th>权限功能说明</th>
        <th>用途和目的</th>
        <th>申请时机</th>
      </thead>
      <tbody>
        <tr>
          <td>READ_PHONE_STATE 读取电话状态(设备 IMSI/IMEI 号）</td>
          <td>读取手机设备标识等信息</td>
          <td>进行广告投放及广告监测归因、反作弊</td>
          <td>开发者在调用需要该权限的SDK功能时进行调用。例如进行广告投放、监测归因与反作弊。</td>
        </tr>
        <tr>
          <td>ACCESS_COARSE_LOCATION 访问粗略位置</td>
          <td>获取粗略地理位置信息</td>
          <td>进行广告投放及反作弊</td>
          <td>开发者在调用需要该权限的SDK功能时进行调用，例如根据粗略位置信息投放广告、广告反作弊。</td>
        </tr>
        <tr>
          <td>ACCESS_FINE_LOCATION 访问精准定位</td>
          <td>获取精确地理位置信息</td>
          <td>进行广告投放及反作弊</td>
          <td>开发者在调用需要该权限的SDK功能时进行调用，例如根据精确位置信息投放广告、广告反作弊。</td>
        </tr>
        <tr>
          <td>WRITE_EXTERNAL_STORAGE 写入外置存储器</td>
          <td>允许应用程序写入外部存储</td>
          <td>应用下载广告投放及广告素材存储</td>
          <td>开发者在调用需要该权限的SDK功能时进行调用。例如下载App包体等功能。</td>
        </tr>
        <tr>
          <td>READ_EXTERNAL_STORAGE 读取外置存储器</td>
          <td>允许应用程序读取外部存储</td>
          <td>应用下载广告投放及广告素材存储</td>
          <td>开发者在调用需要该权限的SDK功能时进行调用。例如下载App包体等功能。</td>
        </tr>
        <tr>
          <td>QUERY_ALL_PACKAGES 应用软件列表</td>
          <td>获取应用软件列表</td>
          <td>进行广告投放及反作弊</td>
          <td>开发者在调用需要该权限的SDK功能时进行调用。例如根据应用软件列表情况进行广告投放、广告反作弊。</td>
        </tr>
      </tbody>
    </table>


    <p class="level4 strong">（2）穿山甲广告 SDK（com.bytedance）</p>
    <p><span class="strong">使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>北京巨量引擎网络技术有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span></p>
    <p>设备标识符（如IMEI、Android ID、OAID、IMSI、ICCID、GAID、MEID，设备序列号build_serial，IDFV、IDFA、ODID），设备MAC地址，IP地址，精确位置信息、粗略位置信息（WiFi列表、WLAN接入点（如SSID、BSSID）），设备传感器信息（加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器），设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间大小、手机系统重启时间、磁盘总空间、系统总内存空间、运营商信息、Wi-Fi状态、网络信号强度、软件列表、应用包名、运行中的进程信息、版本号、应用前后台状态、获取设备硬件序列号、获取Android ID</p>

    <table>
      <thead>
        <th>个性信息类型</th>
        <th>个人信息字段</th>
        <th>用途和目的</th>
      </thead>
      <tbody>
        <tr>
          <td>设备信息</td>
          <td>必选信息： 【Android+iOS】设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间大小等基础信息 【Android】AndroidID、OAID 【iOS】手机系统重启时间、磁盘总空间、系统总内存空间、IDFV 可选信息： 【Android+iOS】设备MAC地址（如为iOS端，则仅适用于IOS3200以下版本） 【Android】设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、硬件序列号build_serial，具体字段因软硬件版本不同而存在差异） 【iOS】设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异） </td>
          <td>广告投放及广告反作弊。 其中，IMEI、IDFA、AndroidID、OAID、设备的MAC地址、设备型号还会用于广告监测归因。 </td>
        </tr>

        <tr>
          <td>网络信息</td>
          <td>必选信息： 【Android+iOS】运营商信息、Wi-Fi状态、网络信号强度 必选信息： 【Android+iOS】IP地址 </td>
          <td>保证网络服务有效性及稳定性。 其中，运营商信息、Wi-Fi状态还会用于广告投放； 广告投放、广告监测归因、广告反作弊 </td>
        </tr>
        <tr>
          <td>应用信息</td>
          <td>必选信息： 【Android】应用包名、运行中的进程信息、版本号、应用前后台状态 可选信息： 【Android】软件列表信息 </td>
          <td>广告投放、广告反作弊 </td>
        </tr>
        <tr>
          <td>传感器信息</td>
          <td>可选信息： 【Android】线性加速度传感器、磁场传感器、旋转矢量传感器 【Android+iOS】加速度传感器、陀螺仪传感器 </td>
          <td>摇一摇、扭一扭等广告投放、广告反作弊 </td>
        </tr>
        <tr>
          <td>广告信息</td>
          <td>必选信息： 【Android+iOS】对广告的展示、点击及转化等交互数据 </td>
          <td>广告监测归因、广告投放统计分析、广告反作弊 </td>
        </tr>
        <tr>
          <td>位置信息</td>
          <td>可选信息： 【Android+iOS】精确位置信息、粗略位置信息（WiFi列表、WLAN接入点（如SSID，BSSID）、基站） </td>
          <td>广告定向投放及广告反作弊 </td>
        </tr>
        <tr>
          <td>性能数据</td>
          <td>必选信息 【Android+iOS】如崩溃数据、性能数据 </td>
          <td>减少App崩溃、提供稳定可靠的服务 </td>
        </tr>
      </tbody>
    </table>


    <p><span class="strong">隐私政策链接：</span>https://www.csjplatform.com/privacy</p>

    
    <p class="strong">个人信息类权限使用详情：</p>


    <table>
      <thead>
        <th>权限</th>
        <th>权限功能说明</th>
        <th>用途和目的</th>
        <th>申请时机</th>
      </thead>
      <tbody>
        <tr>
          <td>READ_PHONE_STATE 读取电话状态(设备 IMSI/IMEI 号）</td>
          <td>读取手机设备标识等信息</td>
          <td>进行广告投放及广告监测归因、反作弊</td>
          <td>开发者在调用需要该权限的SDK功能时进行调用。例如进行广告投放、监测归因与反作弊。</td>
        </tr>
        <tr>
          <td>ACCESS_COARSE_LOCATION 访问粗略位置</td>
          <td>获取粗略地理位置信息</td>
          <td>进行广告投放及反作弊</td>
          <td>开发者在调用需要该权限的SDK功能时进行调用，例如根据粗略位置信息投放广告、广告反作弊。</td>
        </tr>
        <tr>
          <td>ACCESS_FINE_LOCATION 访问精准定位</td>
          <td>获取精确地理位置信息</td>
          <td>进行广告投放及反作弊</td>
          <td>开发者在调用需要该权限的SDK功能时进行调用，例如根据精确位置信息投放广告、广告反作弊。</td>
        </tr>
        <tr>
          <td>WRITE_EXTERNAL_STORAGE 写入外置存储器</td>
          <td>允许应用程序写入外部存储</td>
          <td>应用下载广告投放及广告素材存储</td>
          <td>开发者在调用需要该权限的SDK功能时进行调用。例如下载App包体等功能。</td>
        </tr>
        <tr>
          <td>READ_EXTERNAL_STORAGE 读取外置存储器</td>
          <td>允许应用程序读取外部存储</td>
          <td>应用下载广告投放及广告素材存储</td>
          <td>开发者在调用需要该权限的SDK功能时进行调用。例如下载App包体等功能。</td>
        </tr>
        <tr>
          <td>QUERY_ALL_PACKAGES 应用软件列表</td>
          <td>获取应用软件列表</td>
          <td>进行广告投放及反作弊</td>
          <td>开发者在调用需要该权限的SDK功能时进行调用。例如根据应用软件列表情况进行广告投放、广告反作弊。</td>
        </tr>
      </tbody>
    </table>

    <p class="level4 strong">（3）京准通 SDK</p>
    <p><span class="strong">使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>北京京东世纪贸易有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。获取设备硬件序列号、获取Android ID、获取 MAC 地址</p>
    <p><span class="strong">隐私政策链接：</span>https://jzt.jd.com/gw/agreement</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、设备序列号build_serial、MAC地址。</p>

    <p class="level4 strong">（4）蒂烨 SDK</p>
    <p><span class="strong">使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>蒂烨大数据科技（广州）有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。获取设备硬件序列号、获取Android ID、获取 MAC 地址</p>
    <p><span class="strong">隐私政策链接：</span>https://bxr.im/activity/html/m20200803Agreements/html/dierdodo_policy.html</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、设备序列号build_serial、MAC地址。</p>

    <p class="level4 strong">（5）MMA 中国广告监测通用SDK</p>

    <p><span class="strong">使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>上海亦拓广告有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。获取设备硬件序列号、获取Android ID、获取 MAC 地址</p>
    <p><span class="strong">隐私政策链接：</span>https://mmachina.cn/sdk-privacy/</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、设备序列号build_serial、MAC地址。</p>

    <p style="text-indent:2em">d. 读取手机状态数据<br/>
&lt;uses-permission android:name="android.permission.READ_PHONE_STATE" /&gt;<br/>
该权限用于获取设备识别码、序列号 IMEI，通过 IMEI 对用户进行唯一标识，以便提供服务。</p>
    <p style="text-indent:2em">e. 应用访问地理位置信息<br/>
&lt;uses-permission android:name="android.permission.ACCESS_FINE_LOCATION" /&gt;<br/>
&lt;uses-permission android:name="android.permission.ACCESS_COARSE_LOCATION" /&gt;<br/>
该权限用于获取位置信息，为开发者提供反舞弊功能，剔除作弊设备；同时校正用户的地域分布数据，使报表数据更加准确。</p>
    <p style="text-indent:2em">f. 读取手机内存数据<br/>
&lt;uses-permission android:name="android.permission.WRITE_EXTERNAL_STORAGE" /&gt;<br/>
&lt;uses-permission android:name="android.permission.READ_EXTERNAL_STORAGE" /&gt;<br/>
该权限用于保持设备相关信息，以确保设备唯一标识的准确性，以便精确向目标设备推送消息。在不同App间分享大图或多图文件时使用 。</p>

    <p style="text-indent:2em">g. 检测联网方式<br/>
&lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" /&gt;<br/>
该权限用于检测联网方式，在网络异常状态下避免数据发送，节省流量和电量。</p>
    <p style="text-indent:2em">h. 获取WIFI mac地址<br/>
&lt;uses-permission android:name="android.permission.ACCESS_WIFI_STATE" /&gt;<br/>
该权限用于获取WIFI mac地址，在平板设备或电视盒子上，无法通过IMEI标识设备，我们会将WIFI mac地址作为用户的唯一标识，以便正常提供统计分析服务。</p>
    <p style="text-indent:2em">i. 允许应用程序联网<br/>
&lt;uses-permission android:name="android.permission.INTERNET"  /&gt;<br/>
该权限用于允许应用程序联网和发送统计数据的权限，以便提供统计分析服务。
</p>




    <p class="level4 strong">（6）创智汇聚 SDK（Sigmob SDK）</p>

    <p><span class="strong">使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>北京创智汇聚科技有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。获取设备硬件序列号、获取Android ID、获取 MAC 地址</p>
    <p><span class="strong">隐私政策链接：</span>https://newdocs.toponad.com/docs/1Mn1B7</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、设备序列号build_serial、MAC地址。</p>

    <p style="text-indent:2em">d. 读取手机状态数据<br/>
&lt;uses-permission android:name="android.permission.READ_PHONE_STATE" /&gt;<br/>
该权限用于获取设备识别码、序列号 IMEI，通过 IMEI 对用户进行唯一标识，以便提供服务。</p>
    <p style="text-indent:2em">e. 应用访问地理位置信息<br/>
&lt;uses-permission android:name="android.permission.ACCESS_FINE_LOCATION" /&gt;<br/>
&lt;uses-permission android:name="android.permission.ACCESS_COARSE_LOCATION" /&gt;<br/>
该权限用于获取位置信息，为开发者提供反舞弊功能，剔除作弊设备；同时校正用户的地域分布数据，使报表数据更加准确。</p>
    <p style="text-indent:2em">f. 读取手机内存数据<br/>
&lt;uses-permission android:name="android.permission.WRITE_EXTERNAL_STORAGE" /&gt;<br/>
&lt;uses-permission android:name="android.permission.READ_EXTERNAL_STORAGE" /&gt;<br/>
该权限用于保持设备相关信息，以确保设备唯一标识的准确性，以便精确向目标设备推送消息。在不同App间分享大图或多图文件时使用 。</p>

    <p style="text-indent:2em">g. 检测联网方式<br/>
&lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" /&gt;<br/>
该权限用于检测联网方式，在网络异常状态下避免数据发送，节省流量和电量。</p>
    <p style="text-indent:2em">h. 获取WIFI mac地址<br/>
&lt;uses-permission android:name="android.permission.ACCESS_WIFI_STATE" /&gt;<br/>
该权限用于获取WIFI mac地址，在平板设备或电视盒子上，无法通过IMEI标识设备，我们会将WIFI mac地址作为用户的唯一标识，以便正常提供统计分析服务。</p>
    <p style="text-indent:2em">i. 允许应用程序联网<br/>
&lt;uses-permission android:name="android.permission.INTERNET"  /&gt;<br/>
该权限用于允许应用程序联网和发送统计数据的权限，以便提供统计分析服务。
</p>



    <p class="level4 strong">（7）快手联盟 SDK</p>

    <p><span class="strong">使用目的：</span>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>北京快手广告有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。获取设备硬件序列号、获取Android ID、获取 MAC 地址</p>
    <p><span class="strong">隐私政策链接：</span>https://u.kuaishou.com/home/detail/1220</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、设备序列号build_serial、MAC地址。</p>

    <p style="text-indent:2em">d. 读取手机状态数据<br/>
&lt;uses-permission android:name="android.permission.READ_PHONE_STATE" /&gt;<br/>
该权限用于获取设备识别码、序列号 IMEI，通过 IMEI 对用户进行唯一标识，以便提供服务。</p>
    <p style="text-indent:2em">e. 应用访问地理位置信息<br/>
&lt;uses-permission android:name="android.permission.ACCESS_FINE_LOCATION" /&gt;<br/>
&lt;uses-permission android:name="android.permission.ACCESS_COARSE_LOCATION" /&gt;<br/>
该权限用于获取位置信息，为开发者提供反舞弊功能，剔除作弊设备；同时校正用户的地域分布数据，使报表数据更加准确。</p>
    <p style="text-indent:2em">f. 读取手机内存数据<br/>
&lt;uses-permission android:name="android.permission.WRITE_EXTERNAL_STORAGE" /&gt;<br/>
&lt;uses-permission android:name="android.permission.READ_EXTERNAL_STORAGE" /&gt;<br/>
该权限用于保持设备相关信息，以确保设备唯一标识的准确性，以便精确向目标设备推送消息。在不同App间分享大图或多图文件时使用 。</p>

    <p style="text-indent:2em">g. 检测联网方式<br/>
&lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" /&gt;<br/>
该权限用于检测联网方式，在网络异常状态下避免数据发送，节省流量和电量。</p>
    <p style="text-indent:2em">h. 获取WIFI mac地址<br/>
&lt;uses-permission android:name="android.permission.ACCESS_WIFI_STATE" /&gt;<br/>
该权限用于获取WIFI mac地址，在平板设备或电视盒子上，无法通过IMEI标识设备，我们会将WIFI mac地址作为用户的唯一标识，以便正常提供统计分析服务。</p>
    <p style="text-indent:2em">i. 允许应用程序联网<br/>
&lt;uses-permission android:name="android.permission.INTERNET"  /&gt;<br/>
该权限用于允许应用程序联网和发送统计数据的权限，以便提供统计分析服务。
</p>



    <p class="level4 strong">（8）倍孜SDK </p>

    <p><span class="strong">使用目的：</span>广告投放、广告归因、广告反作弊。基于用户设备信息调整广告投放策略；基于用户设备信息提供统计分析服务；基于用户设备信息进行基础的反作弊分析；基于用户设备信息实现广告正常显示与交互功能的实现；通过崩溃信息，以此来优化代码缺陷，最大程度减少App崩溃；通过收集SDK运行过程中性能数据，以优化SDK的性能；统计广告数据，以用于广告主统计投放结果。包括不限于：请求、展示 、点击 、转化，用于广告流程分析；获取信息只用于功能实现并不会收集与保存信息。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>上海倍孜网络技术有限公司</p>
    <p><span class="strong">隐私政策链接：</span>https://sdk-doc.adn-plus.com.cn/docs/Privacy_Protection</p>
    <p><span class="strong">获取个人信息的范围：</span></p>
    设备标识符（如IMEI、Android ID、OAID、IMSI、ICCID、GAID、MEID，设备序列号build_serial，IDFV、IDFA、ODID），设备MAC地址，IP地址，精确位置信息、粗略位置信息（WiFi列表、WLAN接入点（如SSID、BSSID）），设备传感器信息（加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器），设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间大小、手机系统重启时间、磁盘总空间、系统总内存空间、运营商信息、Wi-Fi状态、网络信号强度、软件列表、应用包名、运行中的进程信息、版本号、应用前后台状态、获取设备硬件序列号、获取Android ID


    <p>【Android+iOS+HarmonyOS】设备品牌、设备型号、设备时区、设备语言、系统版本、UserAgent信息、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、磁盘空间、物理内存、网络类型、运营商、开发者应用名、应用版本号、应用包名、产品交互数据、广告数据(展示、点击、转化)、崩溃数据、性能数据、粗略位置信息、加速度传感器、陀螺仪</p>
    <p>【Android+iOS】系统更新时间、精确位置信息、重力传感器、方向传感器、压力传感器、线性加速度传感器</p>
    <p>【Android+HarmonyOS】OAID</p>
    <p>【iOS+HarmonyOS】设备名称</p>
    <p>【仅Android】cpu、sim卡状态、运行状态</p>
    <p>【仅iOS】开机时间、IDFA、IDFV、磁力传感器</p>


    <p class="level4 strong">（9）AdScope SDK Android</p>

    <p><span class="strong">使用目的：</span>
      广告投放、广告归因、广告反作弊。基于用户设备信息调整广告投放策略；基于用户设备信息提供统计分析服务；基于用户设备信息进行基础的反作弊分析；基于用户设备信息实现广告正常显示与交互功能的实现；通过崩溃信息，以此来优化代码缺陷，最大程度减少App崩溃；通过收集SDK运行过程中性能数据，以优化SDK的性能；统计广告数据，以用于广告主统计投放结果。包括不限于：请求、展示 、点击 、转化，用于广告流程分析；获取信息只用于功能实现并不会收集与保存信息。
    </p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>上海倍孜网络技术有限公司</p>
    <p><span class="strong">隐私政策链接：</span>https://sdkdocv3.beizi.biz/#/zh-cn/guide/UsePrivacy</p>
    <p><span class="strong">获取个人信息的范围：</span></p>
      设备标识符（如IMEI、Android ID、OAID、IMSI、ICCID、GAID、MEID，设备序列号build_serial，IDFV、IDFA、ODID），设备MAC地址，IP地址，精确位置信息、粗略位置信息（WiFi列表、WLAN接入点（如SSID、BSSID）），设备传感器信息（加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器），设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间大小、手机系统重启时间、磁盘总空间、系统总内存空间、运营商信息、Wi-Fi状态、网络信号强度、软件列表、应用包名、运行中的进程信息、版本号、应用前后台状态、获取设备硬件序列号、获取Android ID
    <p>必选信息：</p>
    <p>【双端】设备品牌、设备型号、设备时区、设备语言、系统版本、UserAgent信息、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、磁盘空间、物理内存、网络类型、运营商、开发者应用名、应用版本号、应用包名、交互数据、广告数据(展示、点击、转化)、崩溃数据、性能数据</p>
    <p>【iOS】开机时间、设备名称</p>
    <p>【Android】OAID、sim卡状态、cpu、运行状态</p>
    <p>可选信息：</p>
    <p>【双端】精确位置信息、粗略位置信息、重力传感器、加速度传感器、方向传感器、陀螺仪、压力传感器、线性加速度传感器</p>
    <p>【iOS】IDFA、IDFV、磁力传感器</p>

    <p>SDK调用权限：</p>
    <table border="1" cellpadding="8" cellspacing="0" style="border-collapse:collapse; font-family:Arial, sans-serif;">
      <thead style="background:#f2f2f2;">
      <tr>
        <th>相关权限</th>
        <th>调用时机</th>
        <th>使用目的</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>网络权限</td>
        <td>初始化时</td>
        <td>
          检查设备连网络状态，确保 SDK 与服务端的通讯；<br>
          广告投放及广告监测归因、反作弊
        </td>
      </tr>
      <tr>
        <td>访问网络信息</td>
        <td>初始化时</td>
        <td>
          检查设备连网络状态，确保 SDK 与服务端的通讯；<br>
          应用下载广告投放及广告素材存储；<br>
          广告投放及广告监测归因、反作弊
        </td>
      </tr>
      <tr>
        <td>安装应用</td>
        <td>广告请求时</td>
        <td>
          应用下载广告投放及广告素材存储；<br>
          广告投放及广告监测归因、反作弊
        </td>
      </tr>
      <tr>
        <td>读取内存卡</td>
        <td>下载类广告触发点击</td>
        <td>
          应用下载广告投放及广告素材存储
        </td>
      </tr>
      <tr>
        <td>写入内存卡</td>
        <td>下载类广告触发点击</td>
        <td>
          应用下载广告投放及广告素材存储
        </td>
      </tr>
      <tr>
        <td>访问粗略位置（可选）</td>
        <td>广告请求时</td>
        <td>
          广告投放及广告监测归因、反作弊
        </td>
      </tr>
      <tr>
        <td>访问精准位置（可选）</td>
        <td>广告请求时</td>
        <td>
          广告投放及广告监测归因、反作弊
        </td>
      </tr>
      </tbody>
    </table>
    <p class="level4 strong">3. 消息推送服务</p>
    我们因实现消息推送功能的需要，会使用小米、魅族、华为、OPPO、vivo 手机厂商的第三方 Push SDK。您使用小米、魅族、华为、OPPO、vivo 上述手机时，Push SDK 需要收集 <span class="strong"> 唯一设备标识符、设备运行进程信息、应用程序列表信息</span>。并可能会收集您的手机型号、系统类型、系统版本、联网相关信息，以确保您能正常收到消息推送，以及卸载客户端之后，不会再收到消息推送。
    
    <p class="level4 strong">（1）小米推送 SDK（ Milink SDK）</p>

    <p><span class="strong">使用目的：</span>实现消息推送服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>北京小米科技有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。获取设备硬件序列号、获取Android ID、获取 MAC 地址</p>
    <p><span class="strong">隐私政策链接：</span>https://dev.mi.com/distribute/doc/details?pId=1534</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的小米ID）、设备序列号build_serial、MAC地址。</p>
    <p class="level4 strong">（2）魅族推送 SDK</p>
    <p><span class="strong">使用目的：</span>实现消息推送服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>珠海星纪魅族信息技术有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。获取设备硬件序列号、获取Android ID、获取 MAC 地址</p>
    <p><span class="strong">隐私政策链接：</span>https://open.flyme.cn/docs?id=202</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息、获取应用安装列表（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的魅族ID）、设备序列号build_serial、MAC地址。</p>
    <p class="level4 strong">（3）华为推送 SDK</p>
    <p><span class="strong">使用目的：</span>实现消息推送服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>华为软件技术有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。获取设备硬件序列号、获取Android ID、获取 MAC 地址</p>
    <p><span class="strong">隐私政策链接：</span>https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177</p>
    
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息、获取应用安装列表（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的华为ID）、设备序列号build_serial、MAC地址。</p>
    <p class="level4 strong">（4）OPPO推送 SDK</p>
    <p><span class="strong">使用目的：</span>实现消息推送服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>广东欢太科技有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。获取设备硬件序列号、获取Android ID、获取 MAC 地址</p>
    <p><span class="strong">隐私政策链接：</span>ttps://open.oppomobile.com/new/developmentDoc/info?id=10288</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息、获取应用安装列表（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的OPPO ID）、设备序列号build_serial、MAC地址。</p>
    <p class="level4 strong">（5）vivo推送 SDK</p>
    <p><span class="strong">使用目的：</span>实现消息推送服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>维沃移动通信有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。获取设备硬件序列号、获取Android ID、获取 MAC 地址</p>
    <p><span class="strong">隐私政策链接：</span>https://dev.vivo.com.cn/documentCenter/doc/652</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息、获取应用安装列表（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的vivo ID）、设备序列号build_serial、MAC地址。</p>



    <p class="level4 strong">4. 第三方账号登录、分享服务</p>
    您使用微博、微信、QQ 账号以及其他第三方账号登录我们的产品时，相关SDK需要收集您的第三方账号、设备识别号、联网相关信息；如您使用向微博、微信、QQ 账号以及其他第三方平台分享信息功能，相关 SDK 会收集您的设备识别号、联网相关信息。
    <p class="level4 strong">（1）新浪微博移动SDK</p>
    <p><span class="strong">第三方公司名称：</span>北京微梦创科网络技术有限公司</p>
    <p><span class="strong">共享类型：</span>内嵌SDK</p>
    <p><span class="strong">共享信息：</span>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、设备IP、获取设备硬件序列号、获取Android ID、获取 MAC 地、读取WIFI的SSID、读取WIFI的BSSID</p>
    <p><span class="strong">使用目的：</span>提供微博账号登录、分享内容至微博平台的服务</p>
    <p><span class="strong">使用场景：</span>用户分享内容</p>
    <p><span class="strong">共享方式：</span>（外部）接口共享</p>
    <p><span class="strong">第三方隐私链接：</span>https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE#.E9.9A.90.E7.A7.81.E7.9B.B8.E5.85.B3.E6.9D.A1.E6.AC.BE</p>


    <p class="level4 strong">5. 本机号码一键登录服务</p>
    （1）创蓝闪验 SDK（com.chuanglan.shanyan_sdk）
    <p><span class="strong">使用目的：</span>我们的产品为改善注册及登录界面用户体验，集成第三方创蓝闪验SDK，为用户提供一键登录、号码验证、安全校验服务服务。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>上海璟梦信息科技有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>
      为了实现网关取号技术，创蓝闪验SDK 需要获取本机号码、设备标识符（包括IDFV、OAID）、设备硬件信息（包括设备型号、设备硬件制造商）、操作系统信息（包括操作系统版本）、网络信息（包括网络类型、运营商名称、网络IP地址、网络状态、网络制式）、SIM卡信息（包括SIM卡状态、subId）、应用信息（包括BundleId、包名、包签名）。获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志；获取设备硬件序列号、获取Android ID
    </p>
    <p><span class="strong">隐私政策链接：</span>https://doc.chuanglan.com/document/T98GE1KYCZDMJDHN</p>
    <p class="strong">个人信息类权限使用详情：</p>

    <table border="1" cellpadding="8" cellspacing="0">
      <thead>
      <tr>
        <th>平台</th>
        <th>权限</th>
        <th>使用场景</th>
        <th>使用目的</th>
        <th>申请时机</th>
      </tr>
      </thead>
      <tbody>
      <!-- Android -->
      <tr>
        <td rowspan="5">Android</td>
        <td>android.permission.INTERNET（必选）</td>
        <td>网络通信</td>
        <td>允许应用程序联网，用于访问网关和认证服务器</td>
        <td>调用sdk业务功能时申请</td>
      </tr>
      <tr>
        <td>android.permission.ACCESS_WIFI_STATE（必选）</td>
        <td>查看WiFi状态</td>
        <td>获取WiFi状态，判断是开启WiFi等</td>
        <td>调用功能接口的前置检查</td>
      </tr>
      <tr>
        <td>android.permission.ACCESS_NETWORK_STATE（必选）</td>
        <td>查看网络状态</td>
        <td>获取网络状态，判断是否开启数据、WiFi等</td>
        <td>调用功能接口的前置检查</td>
      </tr>
      <tr>
        <td>android.permission.CHANGE_NETWORK_STATE（必选）</td>
        <td>进行网络切换通信</td>
        <td>允许程序改变网络连接状态，当用户未使用数据流量时，切换为数据流量，以获取用户手机号码</td>
        <td>WiFi和蜂窝网络双开且需要使用功能接口时申请</td>
      </tr>
      <tr>
        <td>android.permission.CHANGE_WIFI_STATE（可选）</td>
        <td>进行网络切换通信</td>
        <td>允许程序改变WiFi连接状态，当用户未使用数据流量时，切换为数据流量，以获取用户手机号码</td>
        <td>WiFi和蜂窝网络双开且需要使用功能接口时申请</td>
      </tr>

      <!-- iOS -->
      <tr>
        <td>iOS</td>
        <td>蜂窝网络权限（必选）</td>
        <td>获取用户手机号</td>
        <td>用于一键获取您的手机号码</td>
        <td>调用网关取号功能时申请</td>
      </tr>

      <!-- Harmony -->
      <tr>
        <td rowspan="3">Harmony</td>
        <td>ohos.permission.INTERNET（必选）</td>
        <td>网络通信</td>
        <td>允许应用程序联网，用于访问网关和认证服务器</td>
        <td>调用sdk业务功能时申请</td>
      </tr>
      <tr>
        <td>ohos.permission.GET_NETWORK_INFO（必选）</td>
        <td>查看网络状态</td>
        <td>获取网络状态，判断是否开启数据、WiFi等</td>
        <td>调用功能接口的前置检查</td>
      </tr>
      <tr>
        <td>ohos.permission.SET_NETWORK_INFO（必选）</td>
        <td>进行网络切换通信</td>
        <td>允许程序改变网络连接状态，当用户未使用数据流量时，切换为数据流量，以获取用户手机号码</td>
        <td>Wi-Fi和蜂窝网络双开且需要使用功能接口时申请</td>
      </tr>
      </tbody>
    </table>


    <p><span class="strong">（2）SDK 名称：</span>号码认证</p>

    <p><span class="strong">SDK 开发者：</span>中移互联网有限公司</p>
    <p><span class="strong">SDK 包名：</span>com.cmic.gen.sdk</p>
    <p><span class="strong">收集信息名称：</span>网络类型、网络地址、运营商类型、本机号码、SIM卡状态、手机设备类型、手机操作系统、硬件厂商</p>
    <p><span class="strong">目的及其用途：</span>识别⽤户的⼿机号码快速登录/号码校验，问题查询、分析、风险控制</p>
    <p><span class="strong">信息处理方式：</span>SDK 自行采集</p>
    <p><span class="strong">协议名称：</span>《中国移动认证服务条款》</p>
    <p><span class="strong">协议链接：</span> https://wap.cmpassport.com/resources/html/contract.html</p>

    <p><span class="strong">（3）SDK 名称   </span>：联通认证SDK</p>
    <p><span class="strong">SDK 开发者：</span>联通在线信息科技有限公司</p>
    <p><span class="strong">SDK 包名：</span>com.unicom.online.account</p>
    <p><span class="strong">收集信息名称：</span>网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商</p>
    <p><span class="strong">目的及其用途：</span>识别⽤户的⼿机号码快速登录/号码校验</p>
    <p><span class="strong">信息处理方式：</span>SDK 自行采集</p>
    <p><span class="strong">协议名称：</span>《中国联通服务与隐私协议条款》</p>
    <p><span class="strong">协议链接：</span>https://ms.zzx9.cn/html/oauth/protocol2.html</p>

    <p><span class="strong">（4）SDK 名称 </span>：天翼账号认证SDK</p>
    <p><span class="strong">SDK 开发者</span>：天翼数字生活科技有限公司</p>
    <p><span class="strong">SDK 包名</span>：cn.com.chinatelecom.account.sdk</p>
    <p><span class="strong">收集信息名称：</span>注册手机号码、本机号码、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本</p>
    <p><span class="strong">目的及其用途：</span>识别⽤户的⼿机号码快速登录/号码校验及业务风控</p>
    <p><span class="strong">信息处理方式：</span>SDK 自行采集</p>
    <p><span class="strong">协议名称：</span>《天翼服务及隐私协议》</p>
    <p><span class="strong">协议链接：</span>https://e.189.cn/sdk/agreement/detail.do?hidetop=true</p>




    <p class="level4 strong">6. 崩溃、故障信息统计服务</p>
    <p class="strong">(1）腾讯Bugly SDK（com.tencent.bugly）</p>
    <p><span class="strong">使用目的：</span>我们的产品集成腾讯Bugly SDK，需要获取运行中进程信息、设备标识符、WiFi地址、运营商信息，用于提供崩溃日志上报、热修复、版本更新推送的服务。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>深圳市腾讯计算机系统有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号报错日志。获取设备硬件序列号、获取Android ID</p>
    <p><span class="strong">隐私政策链接：</span>https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</p>
    <p class="strong">个人信息类权限使用详情：</p>
    
    <table>
      <thead>
        <th>操作系统</th>
        <th>权限名称</th>
        <th>使用目的</th>
        <th>功能场景（申请时机）</th>
      </thead>
      <tbody>
        <tr>
          <td>安卓</td>
          <td>android.permission.INTERNET</td>
          <td>查看网络状态，用于数据上报，实现开发者查看崩溃信息的目的</td>
          <td>在进程启动阶段及Crash闪退时调用，用于上传日志。</td>
        </tr>
        <tr>
          <td>安卓</td>
          <td>android.permission.ACCESS_NETWORK_STAT</td>
          <td>查看网络状态，用于数据上报，实现开发者查看崩溃信息的目的</td>
          <td>在进程启动阶段及Crash闪退时调用，用于上传日志。</td>
        </tr>
        <tr>
          <td>iOS</td>
          <td>网络权限</td>
          <td>查看网络状态，用于数据上报，实现开发者查看崩溃信息的目的</td>
          <td>在进程启动阶段及Crash闪退时调用，用于上传日志。</td>
        </tr>
      </tbody>
    </table>




    <p class="level4 strong">7. 客服反馈服务</p>
    <p>我们会向客服供应商、服务商（如腾讯兔小巢）提供您的用户昵称、设备识别号，以便支持我们进行相关的客户服务、售后服务，提升服务体验。</p>
    <p class="level4 strong">8. 联运登录与支付服务</p>
    <p>为了给您和/或您的终端用户提供登录功能，会使用华为手机厂商的第三方联运 SDK，APP中集成的第三方SDK在静默状态下或在后台运行时会收集您的终端用户的设备相关信息（IMEI号（针对Android Q以及Q以下版本）、OAID、手机型号）和UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的联运账号ID）。同时也会收集您的终端用户的软件相关信息（Android系统和SDK版本号、手机系统的版本号），以此针对不同设备为您的终端用户提供适配的应用服务功能。</p>
    <p>为了给您和/或您的终端用户提供支付功能，会使用华为手机厂商的第三方联运 SDK、支付宝客户端 SDK、微信支付 SDK，APP中集成的第三方SDK在静默状态下或在后台运行时会收集您的终端用户正在使用的应用ID、应用包名、应用商品名称、商品金额和安装渠道、UID和订单信息。订单信息包括：支付类型、订单ID、支付行为路径（包括支付点击、调起、成功、取消、失败）、优惠券、总订单金额、商品码、标识支付场景。</p>
    
    
    


    
    
    <!-- <p class="level4 strong">（1）小米联运 SDK（ XiaomiGameCente SDK）</p>

    <p><span class="strong">使用目的：</span>提供用户小米账号登录功能与联运支付功能。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>北京小米科技有限公司</p>

    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的小米ID）、设备序列号build_serial、MAC地址。</p> -->
    <p class="level4 strong">（1）华为联运应用 SDK（Android版）</p>

    <p><span class="strong">使用目的：</span>提供用户华为账号登录功能与联运支付功能。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>华为软件技术有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。设备信息（设备标识符）、帐号信息（华为帐号ID）、商业公开发布的内容（应用基本信息）、设备信息（国家码、操作系统、产品品牌）、应用信息（内容下载渠道、应用功能设置、应用使用记录）、设备硬件信息（设备类型）；获取设备硬件序列号、获取 MAC 地址</p>
    <p><span class="strong">隐私政策链接：</span>https://developer.huawei.com/consumer/cn/doc/AppGallery-connect-Guides/appgallerykit-app-sdk-security-0000001714810945</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的华为ID）、设备序列号build_serial、MAC地址。</p>


    
    

    <p><span class="strong">（2）支付宝客户端 SDK</span></p>
    <p><span class="strong">使用目的：</span></p>
    <p style="text-indent:2em">a. 保障用户账户和资金安全以及支付服务的安全稳定运行。</p>
    <p style="text-indent:2em">b. 履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。</p>
    <p style="text-indent:2em">c. 实现网络链路的选择和优化，以提升用户体验。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>支付宝（中国）网络技术有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表；开放匿名设备标识符、MAC地址、IMEI信息、传感器、设备硬件序列号。</p>
    <p><span class="strong">隐私政策链接：</span>https://opendocs.alipay.com/common/02kiq3</p>
    <p><span class="strong">个人信息类权限使用详情：</span></p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的vivoID）、设备序列号build_serial、MAC地址。</p>



    <p><span class="strong">（3）微信支付 SDK</span></p>
    <p><span class="strong">使用目的：</span></p>
    <p style="text-indent:2em">a. 保障用户账户和资金安全以及支付服务的安全稳定运行。</p>
    <p style="text-indent:2em">b. 履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。</p>
    <p style="text-indent:2em">c. 实现网络链路的选择和优化，以提升用户体验。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>深圳市腾讯计算机系统有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表；开放匿名设备标识符、MAC地址、IMEI信息、传感器、设备硬件序列号。</p>
    <p><span class="strong">隐私政策链接：</span>https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</p>
    <p><span class="strong">个人信息类权限使用详情：</span></p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的vivoID）、设备序列号build_serial、MAC地址。</p>

    <p>我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
    <p>提供技术服务的第三方SDK提供商。关于提供商的身份、收集个人信息的目的、方式、范围情况，请您详细参见本政策附件一、二。</p>

    <p><span class="strong">（4）华为应用内支付SDK</span></p>
    <p><span class="strong">使用目的：</span>提供用户华为联运支付功能。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>华为软件技术有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。设备信息（设备标识符）、帐号信息（华为帐号ID）、商业公开发布的内容（应用基本信息）、设备信息（国家码、操作系统、产品品牌）、应用信息（内容下载渠道、应用功能设置、应用使用记录）、设备硬件信息（设备类型）；获取设备硬件序列号、获取 MAC 地址。</p>
    <p><span class="strong">隐私政策链接：</span>https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050044906</p>
    <p><span class="strong">个人信息类权限使用详情：</span></p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的华为ID）、设备序列号build_serial、MAC地址。</p>

    <p class="level4 strong">9.资源加载服务</p>
    <p>为了给您提供下载音频、图片资源的产品服务，我们需要接入七牛SKD以实现数据资源传输功能，以下将详细列出七牛 SDK 的各项业务功能及为实现该功能所需收集的个人信息情况，请仔细阅读下述信息清单了解各类七牛SDK（包括调用的第三方 SDK（如有））收集个人信息的类型、用途以及实现的功能目的。</p>
    <p class="strong">（1）七牛SDK</p>
    <p><span>使用目的：</span>提供音频文件下载完整性校验、以及用户帐号头像上传的服务</p>
    <p><span>处理方式：</span>第三方自行处理 </p>
    <p><span>第三方名称：</span>上海七牛信息技术有限公司</p>
    <p><span>获取个人信息的范围：</span>设备品牌、型号、操作系统版本、处理器信息、内存使用情况、IP 地址、网络类型及连接信息、读取设备外部存储空间、获取设备硬件序列号、获取 MAC 地址</p>
    <p><span>隐私政策链接：</span>https://developer.qiniu.com/pili/8027/sdk-privacy-policy</p>



    <p>我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</p>





    <p class="level3 strong">（三）基于系统权限的附加功能服务</p>
    <p>我们在向您提供的以下附加服务中可能会收集和使用您的个人信息以及申请设备权限。如果您不提供这些信息，不会影响您使用我们客户端的浏览、搜索、购买基本服务，但您可能无法获得这些附加服务给您带来的用户体验。这些信息是需要您配合开启相应的设备权限方可获取，因此您 可以通过设备设置页面相应权限进行管理。这些附加服务包括：</p>
    <p class="level4 strong">1. Android 版本基于系统权限的功能服务</p>
    <p><span class="strong">（1）基于存储空间权限的附加服务：</span>您在小睡眠内更新个人头像时，小睡眠会请求获取存储空间权限用于访问相册，以确保可以正常选择头像图片；在小睡眠内使用记录睡眠功能时，小睡眠会请求获取存储空间权限用于保存睡眠文件。</p>
    <p><span class="strong">（2）基于录音权限的附加服务：</span>您在小睡眠内使用宁静空间功能时，小睡眠会请求获取录音权限，以保障正常运行环境噪音分析算法，完善该功能体验流程；在小睡眠内使用记录睡眠功能时，小睡眠会请求获取录音权限权限用于帮助分析睡眠质量。</p>
    <p><span class="strong">（3）基于相机权限的附加服务：</span>您在小睡眠内使用小实验功能时，小睡眠会请求获取相机权限，以提供分析心率变化服务，完善功能体验流程；在小睡眠内更新个人头像时，小睡眠会请求获取相机权限，以确保可以通过拍照的方式更新个人头像。</p>
    <p class="level4 strong">2. iOS 版本基于系统权限的功能服务</p>
    <p><span class="strong">（1）基于录音权限的附加服务：</span>您在小睡眠内使用宁静空间功能时，小睡眠会请求获取录音权限，以保障正常运行环境噪音分析算法，完善该功能体验流程；在小睡眠内使用记录睡眠功能时，小睡眠会请求获取录音权限权限用于帮助分析睡眠质量。</p>
    <p><span class="strong">（2）基于相机权限的附加服务：</span>您用户在小睡眠内使用小实验功能时，小睡眠会请求获取相机权限，以为用户提供分析心率变化服务，完善功能体验流程；用户在小睡眠内更新个人头像时，小睡眠会请求获取相机权限，以保障用户确保可以通过拍照的方式更新个人头像。</p>
    <p><span class="strong">（3）基于 Health Kit 数据的附加服务：</span>当你需要使用Health Kit（中文名叫健康，后续文案表述统一为Health
    Kit）服务与我们产生数据链接时，首先需要你“打开小睡眠”-“我的”-“更多设置”-打开“健康中心”（默认关闭），此时，我们会明确告知你我们需要获取数据及简要功能说明，如你确认需要使用Health
    Kit服务，请你点击“同意”，反之，你可以“拒绝”。</p>

    <p style="text-indent:2em">b. 当你同意我们与Health Kit服务产生数据链接时，请你在“睡眠分析”类目中允许“小睡眠”睡眠数据（主要是卧床时间）写入到Health Kit里，这将有利于你更好更方便管理睡眠，除此之外，我们承诺不会从Health
    Kit获取其他无关数据。</p>

    <p style="text-indent:2em">c. 我们承诺你通过我们使用Health Kit的数据不会用于广告或应用其他商业化服务目的。同时请你也注意，你使用我们服务可能会存在广告，但是你使用Health Kit中的数据不会用于广告或应用其他商业化服务目的。</p>

    <p style="text-indent:2em">d. 我们承诺不会向任何第三方展示、出售任何Health Kit获取数据，并且我们承诺建立严密技术措施确保你数据的安全。</p>
    <p>您理解并同意，上述附加服务可能需要您在您的设备中开启您的摄像头（相机）、相册（图片库）、麦克风（语音）、Health
    Kit（健康）。您可在您的设备设置，如果因为更新版本的问题，在您的App上述路径无法找到关闭通讯录权限的选项，您需要去您的设备设置中针对小睡眠App关闭通讯录权限。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</p>

    <p class="level3">（四）客户端调用权限与用途说明</p>
    <p>在您的使用我方客户端功能服务的过程中，体验功能需要调用客户端或SDK时，将会调用如下设备权限，以保障正常的功能实现。为了您更好的理解与使用我们的功能服务，您可以通过下方列举的权限使用说明进行了解：</p>

    <p>1.  允许程序访问<br/>
    <code>&lt;uses-permission android:name="android.permission.GET_TASKS" /&gt;</code><br/>
    该权限用于闪验SDK进行数据切换；小米SDK的消息推送服务。</p>

    <p>2. 允许更改手机设置<br/>
    &lt;uses-permission android:name="android.permission.WRITE_SETTINGS" /&gt;<br/>
    该权限用于闪验SDK增加电信号在wifi+移动数据下取号成功几率。</p>

    <p>3. 获取手机状态<br/>
    &lt;uses-permission android:name="android.permission.READ_PHONE_STATE" /&gt;<br/>
    该权限用于闪验SDK 获取IMSI用于判断双卡和换卡。</p>


    <p>4. 获取wifi状态<br/>
    &lt;uses-permission android:name="android.permission.ACCESS_WIFI_STATE" /&gt;<br/>
    该权限用于基础的连接网络功能。</p>

    <p> 5. 获取网络状态<br/>
    &lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" /&gt;<br/>
      该权限用于闪验SDK在临时取号时切换到移动数据；用于基础的连接网络功能。</p>

    <p> 6. 改变wifi状态<br/>
    &lt;uses-permission android:name="android.permission.CHANGE_WIFI_STATE" /&gt;<br/>
      该权限用于闪验SDK在临时在取号时切换到移动数据。</p>

    <p> 7. 访问网络<br/>
    &lt;uses-permission android:name="android.permission.INTERNET" /&gt;<br/>
      该权限用于基础的连接网络功能。</p>

    <p> 8. 写入文件<br/>
    &lt;uses-permission     android:name="android.permission.WRITE_EXTERNAL_STORAGE" /&gt;<br/>
      该权限用于读取音频文件、记录睡眠文件。</p>

    <p> 9. 读取文件<br/>
    &lt;uses-permission android:name="android.permission.READ_EXTERNAL_STORAGE" /&gt;<br/>
      该权限用于存放音频文件、记录睡眠文件。</p>

    <p> 10. 照相机<br/>
    &lt;uses-permission android:name="android.permission.CAMERA" /&gt;<br/>
      该权限用于小实验功能提供分析心率变化服务；通过拍照的方式更新个人头像。</p>

    <p> 11. 设置闹钟<br/>
    &lt;uses-permission android:name="com.android.alarm.permission.SET_ALARM" /&gt;<br/>
      该权限用于记录睡眠功能设置唤醒闹铃。</p>

    <p> 12. 加入电池优化白名单<br/>
    &lt;uses-permission android:name="android.permission.REQUEST_IGNORE_BATTERY_OPTIMIZATIONS" /&gt;<br/>
      该权限用于保障小睡眠后台运行稳定性。</p>

    <p> 13. 更改声音设定<br/>
    &lt;uses-permission     android:name="android.permission.MODIFY_AUDIO_SETTINGS" /&gt;<br/>
      该权限用于小睡眠无痛唤醒闹铃功能。</p>

    <p> 14. 获取精确定位<br/>
    &lt;uses-permission android:name="android.permission.ACCESS_FINE_LOCATION" /&gt;<br/>
      该权限用于友盟+移动统计SDK的数据分析服务。</p>

    <p> 15. 获取粗略定位<br/>
    &lt;uses-permission android:name="android.permission.ACCESS_COARSE_LOCATION" /&gt;<br/>
      该权限用于友盟+移动统计SDK的数据分析服务。</p>

    <p> 16. 手机振动<br/>
    &lt;uses-permission android:name="android.permission.VIBRATE" /&gt;<br/>
      该权限用于记录睡眠功能提醒用户进入睡眠状态。</p>

    <p> 17. 添加快捷方式<br/>
    &lt;uses-permission android:name="com.android.launcher.permission.INSTALL_SHORTCUT" /&gt;<br/>
      该权限用于无痛唤醒闹钟功能添加快捷方式。</p>

    <p> 18. 唤醒锁<br/>
    &lt;uses-permission android:name="android.permission.WAKE_LOCK" /&gt;<br/>
      该权限用于保障记录睡眠服务进程存活。</p>

    <p> 19. 手机电源管理<br/>
    &lt;uses-permission android:name="android.permission.DEVICE_POWER" /&gt;<br/>
      该权限用于保障记录睡眠服务进程存活。</p>

    <p> 20. 安装App<br/>
    &lt;uses-permission android:name="android.permission.REQUEST_INSTALL_PACKAGES" /&gt;<br/>
      该权限用于提供App版本更新功能。</p>

    <p> 21. 建立前台服务<br/>
    &lt;uses-permission android:name="android.permission.FOREGROUND_SERVICE" /&gt;<br/>
      该权限用于音频服务、闹钟服务、记录睡眠。</p>

    <p> 22. 录音权限<br/>
    &lt;uses-permission android:name="android.permission.RECORD_AUDIO" /&gt;<br/>
      该权限用于宁静空间功能和记录睡眠，运行环境噪音分析算法。</p>

    <p> 23. 推送通知<br/>
    &lt;uses-permission android:name="com.coloros.mcs.permission.RECIEVE_MCS_MESSAGE" /&gt;<br/>
      该权限用于推送通知服务。</p>

    <p> 24. 推送通知<br/>
    &lt;permission android:name="com.psyone.brainmusic.permission.receiver" /&gt;<br/>
      该权限用于推送通知服务。</p>

    <p> 25. 推送通知<br/>
    &lt;permission android:name="com.psyone.brainmusic.permission.MIPUSH_RECEIVE"/&gt;<br/>
      该权限用于小米推送通知服务。</p>

    <p> 26. 推送通知<br/>
    &lt;uses-permission android:name="com.heytap.mcs.permission.RECIEVE_MCS_MESSAGE" /&gt;<br/>
      该权限用于推送通知服务。</p>

    <p> 27. 推送通知<br/>
    &lt;uses-permission android:name="com.meizu.flyme.push.permission.RECEIVE" /&gt;<br/>
      该权限用于推送通知服务。</p>

    <p> 28. 推送通知<br/>
    &lt;permission android:name="com.psyone.brainmusic.push.permission.MESSAGE" android:protectionLevel="0x2" /&gt;<br/>
      该权限用于推送通知服务。</p>

    <!-- <p> 29. 推送通知<br/>
    &lt;uses-permission android:name="com.psyone.brainmusic.push.permission.MESSAGE" /&gt;<br/>
      该权限用于推送通知服务。</p> -->

   <p>  29. 推送通知<br/>
    &lt;uses-permission android:name="com.meizu.c2dm.permission.RECEIVE" /&gt;<br/>
     该权限用于魅族推送通知服务。</p>

    <p> 30. 推送通知<br/>
    &lt;permission android:name="com.psyone.brainmusic.permission.C2D_MESSAGE"    android:protectionLevel="0x2" /&gt;<br/>
      该权限用于推送通知服务。</p>

    <!-- <p> 32. 推送通知<br/>
    &lt;uses-permission android:name="com.psyone.brainmusic.permission.C2D_MESSAGE" /&gt;<br/>
      该权限用于推送通知服务。</p>

    <p> 33. 推送通知<br/>
    &lt;uses-permission android:name="com.psyone.brainmusic.permission.MIPUSH_RECEIVE" /&gt;<br/>
      该权限用于小米推送通知服务。</p> -->

    <p> 31. 照相机<br/>
    &lt;uses-feature android:name="android.hardware.camera"  android:required="false" /&gt;<br/>
      该权限用于小实验功能提供分析心率变化服务；通过拍照的方式更新个人头像。</p>

    <p> 32. 照相机自动对焦功能<br/>
    &lt;uses-feature     android:name="android.hardware.camera.autofocus"    android:required="false" /&gt;<br/>
      该权限用于过拍照的方式更新个人头像。</p>

    <p> 33. 应用顶层浮窗<br/>
    &lt;uses-permission android:name="android.permission.SYSTEM_ALERT_WINDOW" /&gt;<br/>
      该权限用于提供记录睡眠的浮窗功能。</p>

    <p> 34. OPPO手表<br/>
    &lt;uses-permission android:name="com.heytap.wearable.oms.permission.TRACSPORT" /&gt;<br/>
      该权限用于设备连接OPPO手表。</p>

    <p> 35. 允许挂载和反挂载文件系统可移动存储<br/>
    &lt;uses-permission android:name="android.permission.MOUNT_UNMOUNT_FILESYSTEMS" /&gt;<br/>
      该权限用于SD卡读写功能。</p>
    <p> 36. 读取日志<br/>
    &lt;uses-permission android:name="android.permission.READ_LOGS" /&gt;<br/>
该权限用于采集日志信息以排查问题。</p>
    <p> 37. 自启动或关联启动<br/>
    &lt;uses-permission android:name="android.permission.RECEIVE_BOOT_COMPLETED"  /&gt;<br/>
该权限用于实现闹钟唤醒功能。</p>
    <p class="level3">（五）其他</p>
    <p class="strong">1．若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。若其中涉及儿童个人信息的，您需在发布前取得对应儿童监护人的同意，前述情形下监护人有权通过本政策第九条的途径联系我们，要求更正或删除涉及儿童个人信息的内容。</p>
    <p class="strong">2．若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。</p>
    <p>若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们的专业安全团队对个人信息会进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。</p>
    <p>我方平台涉及嵌入第三方代码、插件传输个人信息的情形逐项列举，详见本政策附件一。</p>
    <p class="strong">3. 征得授权同意的例外</p>
    <p>您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意，且我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：</p>
    <p>(1) 与国家安全、国防安全有关的；</p>
    <p>(2) 与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>(3) 与犯罪侦查、起诉、审判和判决执行司法或行政执法有关的；</p>
    <p>(4) 出于维护您或其他个人的生命、财产重大合法权益但又很难得到本人同意的；</p>
    <p>(5) 您自行向社会公众公开的个人信息；</p>
    <p>(6) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道。</p>
    <p>(7) 根据与您签订和履行相关协议或其他书面文件所必需的；</p>
    <p>(8) 用于维护所提供的产品及/或服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障；</p>
    <p>(9) 为合法的新闻报道所必需的；</p>
    <p>(10) 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
    <p>(11) 法律法规规定的其他情形。</p>
    <p class="level2">二、心潮科技公司如何使用Cookie以及同类技术</p>
    <p>Cookie 和同类技术是互联网中普遍使用的技术。当您使用我方客户端相关服务时，我们可能会使用相关技术收集您的信息。我们使用 Cookie 和 同类技术主要为了实现以下功能或服务：</p>
    <p class="level3 strong">（一）保障产品与服务的安全、高效运转</p>
    <p>我们可能会设置认证与保障安全性的 Cookie 或匿名标识符，使我们确认您是否安全登录服务，或者 是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。</p>
    <p class="level3 strong">（二）帮助您获得更轻松的访问体验</p>
    <p>使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容的步骤和流程（例如：表单填写）。</p>
    <p>您可以通过浏览器设置拒绝或管理Cookie以及同类技术的使用；但请注意，如果停用Cookie，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</p>
    <p class="level2">三、心潮科技公司如何使用、转移、披露您的个人信息</p>
    <p class="level3">（一）共享和披露</p>
    <p>除下列情形外，我们不会与任何其他第三方共享您的个人信息。</p>
    <p><span class="strong">1. 在获得您的明确同意或授权或您主动选择的情况下共享。</span>获得您的明示授权或明确同意后，我们会与其他公司、组织和个人分享您的个人信息。例如，如果我们委托第三方向您提供产品或服务（如产品寄送、用户活动、礼品赠送时），我们会在征得您明示同意后将上述信息共享给第三方，如果您拒绝提供此类信息，我们将无法完成相关交付服务。只有您选择同意，我们才会共享您的个人敏感信息。获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息。</p>
    <p><span class="strong">2. 在法定情形下的共享和披露。</span>我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。例如，如果我们确定您出现违反法律法规或严重违反我方相关协议规则的情况，或为保护我方客户端及用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或我方客户端相关协议规则，在征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及我方平台已对您采取的措施。例如，若您或您使用的账号发布非法言论、而严重违反我方规则、触犯法律法规和/或违背公序良俗，造成重大社会影响，给我方造成声誉损失，我们可能会披露您的信息与处罚情况。</p>
    <p><span class="strong">3. 向我方的关联方分享您的个人信息。</span>与关联公司间共享：为便于我们基于关联账号共同向您提供服务，推荐您可能感兴趣的信息或保护我方关联公司或其他用户或公众的人身财产安全免遭侵害，在经过您的授权同意后，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息（如为便于您使用我方账号登录并使用我们关联公司产品或服务，我们会向关联公司共享您必要的个人信息），且受本隐私信息保护政策中所声明目的的约束。如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的明示授权同意。</p>
    <p><span class="strong">4. 与授权合作伙伴共享。您授权同意</span>我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私信息保护政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到为其履行职责所需信息，且不得将此信息用于其他任何目的。</p>
    <p>目前，我们的授权合作伙伴包括以下类型：</p>
    <p class="strong">（1）广告监测、数据统计、数据分析服务类的授权合作伙伴。为维护/改进我们的产品/服务，为您提供更好的内容，我们可能会接入提供该服务的指定合作伙伴友盟、优量汇、穿山甲、京准通读取您的设备识别号、读取设备IP、联网相关信息，用于分析您使用我们的服务情况、优化广告投放。</p>
    <p class="strong">我们的产品集成友盟+移动统计SDK适用于App统计分析场景。友盟+移动统计SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息、读取OAID）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。</p>
    <p>除上述得到您的许可的情形外，我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或手机号码，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴共享。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。</p>
    <p class="strong">请您理解，单独的设备信息、日志信息及其他无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。</p>
    <p><span class="strong">（2）供应商、服务提供商和其他合作伙伴。</span>我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴（如Bugly、创蓝），这些支持包括我们委托提供的技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、支付便利或进行学术研究和调查，进行Bug或者崩溃统计、提升登录体验，实现网关取号。为了提供客户服务，我们会向客服供应商、服务商（如腾讯兔小巢）提供您的用户昵称、设备识别号，以便支持我们进行相关的客户服务、售后服务，提升服务体验。</p>
    <p>（3）为了使您能够接收信息推送、在第三方平台分享信息、使用位置服务的必要的功能用途，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序。如您使用华为/小米/魅族/OPPO/vivo手机时，华为/小米/魅族/OPPO/vivo Push SDK需要读取您的设备识别号、联网相关信息，用于推送/下发通知栏消息；如您使用微博、微信、QQ账号以及其他第三方账号登录我们的产品时，相关SDK需要收集您的第三方账号、设备识别号、联网相关信息；如您使用向微博、微信、QQ账号以及其他第三方平台分享信息功能，相关SDK会收集您的设备识别号、联网相关信息。</p>
    <p>我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
    <p>提供技术服务的第三方SDK提供商。关于提供商的身份、收集个人信息的目的、方式、范围情况，请您详细参见本政策附件一、二。</p>
    <p><span class="strong">5. 协助处理争议。</span>如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议。如交易任何投诉一方、司法机构或行政执法机构提出信息披露请求的，我方会视情况向该上述机构提供被投诉用户的联络方式及个人必要信息，以促成交纠纷的解决。我方平台仅在法律有明确规定的情况下承担相应的法律责任。</p>
    <p><span class="strong">6. 提供和改进产品和服务。</span>为了进一步完善产品或服务，提供更优质的用户体验，心潮科技公司将使用您提供的信息自行或提供给数据服务商进行数据统计、分析，以评估、维护和改进心潮科技公司产品或服务的性能。<span class="strong">这些信息在使用前会经过匿名化处理的，将不会包含您的任何身份识别信息。</span></p>
    <p><span class="strong">7. 数据转移。</span>若心潮科技公司发生重组、合并、分立、清算或资产出售时，您的信息将作为交易标的转移到新的主体，在本政策变更前，您的个人信息仍然受到本个人信息保护政策的保护。</p>
    <p class="level3">（二）转让</p>
    <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <p>1. 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
    <p>2.在我方服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</p>
    <p class="level3">（三）共享、转让、披露个人信息时事先征得授权同意的例外</p>
    <p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
    <p>1.与国家安全、国防安全有关的；</p>
    <p>2.与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3.与犯罪侦查、起诉、审判和判决执行有关的；</p>
    <p>4.出于维护您或其他个人的生命、财产重大合法权益但又很难得到本人同意的；</p>
    <p>5.您自行向社会公众公开的个人信息；</p>
    <p>6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道。</p>
    <p>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
    <p class="strong">如您不同意我们按照上述条款向第三方提供您的个人信息，请您立即停止使用我方客户端服务。</p>
    <p class="level2">四、心潮科技公司如何存储信息</p>
    <p class="level3">（一）信息存储的地点</p>
    <p>我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</p>
    <p>1.法律法规有明确规定；</p>
    <p>2.获得您的明确授权；</p>
    <p>针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。</p>
    <p class="level3">（二）信息存储期限</p>
    <p>我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。而我们判断前述期限的标准包括：</p>
    <p class="strong">1、完成与您相关的服务目的、维护相应服务及业务记录、应对您可能的查询或投诉；</p>
    <p class="strong">2、保证我们为您提供服务的安全和质量；</p>
    <p class="strong">3、您是否同意更长的留存期间；</p>
    <p class="strong">4、是否存在保留期限的其他特别约定。</p>
    <p>在您的个人信息超出保留期限后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</p>
    <p class="level3">（三）信息删除和匿名化处理</p>
    如本公司服务决定停止运营，我们将在相关服务停止运营后停止继续收集您的个人信息。我们将以公告形式将停止运营通知向您送达。对已持有的您的个人信息将进行删除或匿名化处理。涉及儿童个人信息的，我们会一并将停止运营的通知及时告知儿童监护人。
    <p class="level2">五、 心潮科技公司如何保护您的个人信息安全</p>
    为确保我们所收集的您的个人信息安全，我们承诺将努力达到合理的安全水平，现将具体安全措施和安全能力陈述如下：
    <p class="level3">（一）技术安全防护</p>
    为保障您的信息安全，我们努力采取各种符合业界标准的合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。
    <p class="level3">（二）安全体系保证</p>
    我们有行业先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术方面多维度提升整个系统的安全性。目前，为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入安全风险，更准确地识别违反法律法规或我方客户端相关协议规则的情况，我方平台对系统进行了等级保护。
    <p class="level3">（三）人员安全管理</p>
    我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况以及其他措施。我方会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我方将尽力做到使您的信息不被泄漏、毁损或丢失。我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
    <p class="level3">（四）敏感信息及保护提示</p>
    <p><span class="strong">1. 个人敏感信息保护注意：</span>您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，例如您的头像图片上传，例如您在评论时选择上传包含的个人信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</p>
    <p><span class="strong">2. 您的账号均有安全保护功能，请妥善保管您的账号信息。</span>我方将通过向其它服务器备份、对用户密码进行加密以及其他安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。</p>
    <p class="level3">（五）信息披露提示及密码泄露处理</p>
    请注意互联网并非绝对安全的环境。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是你的账号及密码发生泄露，请您立即联络我方客服，以便我方采取相应措施。
    <p class="level3">（六）信息安全事件处理</p>
    在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。事件相关情况我们将以邮件、电话、推送通知、短消息的方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
    <p class="level3">（七）儿童个人信息安全</p>
    <p>我们严格设定儿童个人信息访问权限，对可能接触到儿童个人信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童个人信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。</p>
    <p>我们已制定儿童个人信息安全事件应急预案，定期组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。在不幸发生儿童个人信息安全事件后，我们将按照法律法规的要求，及时向儿童及其监护人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、儿童及其监护人可自主防范和降低风险的建议、对儿童及其监护人的补救措施。我们将及时将事件相关情况以App推送通知、发送邮件/短消息的方式告知儿童及其监护人。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童个人信息安全事件的处置情况。若儿童及其监护人的合法权益受损，我们将承担相应的法律责任。</p>
    <p class="level2">六、 未成年人保护</p>
    <p>我们非常重视对未成年人的个人信息保护。如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本隐私信息保护政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。</p>
    <p>若您是儿童的父母或其他监护人，请您关注您监护的儿童是否是在取得您的授权同意之后使用我们的服务。如您对您所监护的儿童的个人信息有疑问，请通过第九章节中的联系方式与我们联系。</p>
    <p class="level2">七、 您如何管理您的信息</p>
    我们按《中华人民共和国网络安全法》的要求，通过提供便捷的方法，让您可以访问、更正及删除自己的账号信息或使用我们的服务时您提供的其他个人信息。您可以通过如下方式访问及管理您的个人信息：
    <p class="level3">（一）访问您的个人信息</p>
    <p>您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：</p>
    <p>账号信息——如果您希望访问或编辑您的账号中的个人基本资料信息，您可以登录账号后进入“账号资料设置”执行此类操作。</p>
    <!-- <p>账号信息——如果您希望访问或编辑您的账号中的个人基本资料信息、或注销您的账号，您可以登录账号通过“账号与资料”执行此类操作；例如您可以移动客户端“我的 - 账号与资料”查询、修改自己的个人资料、隐私设置并修改您的个人注册信息。</p> -->
    <p class="level3">（二）更正或补充您的个人信息</p>
    当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过“（一）访问您的个人信息”中列明的方式提出更正或补充申请。
    <p class="level3">（三）删除您的个人信息</p>
    <p>您可以通过“（一）访问您的个人信息”中列明的方式删除您的部分个人信息。</p>
    <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
    <p class="strong">1．如果我们处理个人信息的行为违反法律法规；</p>
    <p class="strong">2．如果我们收集、使用您的个人信息，却未征得您的明确同意；</p>
    <p class="strong">3．如果我们处理个人信息的行为严重违反了与您的约定；</p>
    <p class="strong">4．如果您不再使用我们的产品或服务，或您主动注销了账号；</p>
    <p class="strong">5．如果我们永久不再为您提供产品或服务</p>
    <p>若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。</p>
    <p>当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
    <p class="level3">（四）改变您授权同意的范围</p>
    <p>每个业务功能需要一些基本的个人信息才能得以完成。除此之外，对于额外个人信息的收集和使用，您可以与我方客服联系，给予或收回您的授权同意。</p>
    <p>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
    <p class="level3">（五）个人信息主体注销账号</p>
    <p>现阶段，您可联系我方客服。我们在核实用户身份后，会注销您的手机号和使用记录，达到注销的效果。</p>
    <!-- <p>现阶段，我方已通过技术方式实现，使您可以自行在“注销账号”页面（小睡眠移动客户端“我的 - 账号与资料 -
    注销账号”）提交账号注销申请。若未能申请成功，您也可联系我方客服。我们在核实用户身份后，会注销您的手机号和使用记录，达到注销的效果。</p> -->
    <p class="strong">在您主动注销账号之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或对其匿名化处理。</p>
    <p class="level3">（六）约束信息系统自动决策</p>
    在某些业务功能中，我们可能仅依据信息系统、算法在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害我方平台商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。
    <p class="level3">（七）退订</p>
    如您发现收到了不属于您主动搜索、浏览的内容和产品、服务信息推送，如您不希望接收上述信息，可通过原路径进行退订，例如短信推送可以直接回复相关的退订口令，如会员连续包月服务在客户端内“会员 - 续费管理”取消您的连续包月服务。
    <p class="level3">（八）响应您的上述请求</p>
    为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
    <p class="level2">八、个人信息保护政策的修订</p>
    <p class="strong">心潮科技公司可能对本政策进行不定期修改，协议修改后，心潮科技公司将在相关页面或以其他合适的方式公布修改的内容。如果您不同意本协议的修改，请立即停止使用平台或取消已经获得的服务；如果您选择在本政策修改后继续访问或使用平台或服务的，则视为您已接受本政策的修改。</p>
    <p>您与心潮科技公司签署的本政策所列明的条款，并不能完全涵盖您与心潮科技公司所有的关于个人信息的权利和义务。因此，<span class="strong"> 心潮科技公司公布其他声明、各形式规则均视为本政策之补充条款，为本政策不可分割的组成部分，与本协议具有同等法律效力。</span></p>
    <p>未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在心潮科技公司专门链接上发布对隐私权政策所做的任何变更和更新。
    对于重大变更，我们还会提供更为显著的通知（包括我们会通过我方平台公示的方式进行通知甚至向您提供弹窗提示）。</p>
    <p>本政策所指的重大变更包括但不限于：</p>
    <p>1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</p>
    <p>2.我们在控制权方面发生重大变化。如并购重组引起的所有者变更；</p>
    <p>3.个人信息共享、转让或公开披露的主要对象发生变化；</p>
    <p>4.您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
    <p>5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
    <p>6.个人信息安全影响评估报告表明存在高风险时。</p>
    <p>为了您能及时接收到通知，建议您在联系方式更新时及时通知我们。如您在本政策更新生效后继续使用我们的服务，即代表您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。我们鼓励您在每次使用我们服务时都查阅本政策。您可以在小睡眠客户端通过“我的-关于我们-隐私政策”中查看本政策。</p>
    <p class="level2">九、如何联系心潮科技公司</p>
    <p>您可以通过以下方式与我们联系，我们将在15个工作日内回复您的请求：
    我们设立了个人信息保护专职部门，如您对心潮科技隐私信息保护政策、儿童个人信息有任何疑问、意见或建议，您可通过以下方式与我们取得联系：<br/>
    我方地址：广州市海珠区新滘中路10号之三101、之四101、之五101<br/>
    联系人：心潮科技客服部<br/>
    联系方式：020-87351934<br/>
    联系邮箱：office@heartide.com</p>

    <p>本协议签订地为中华人民共和国广州市海珠区，因本协议生效、履行、解释及使用心潮科技公司服务而产生或与本协议相关的一切争议、权利主张或其他事项，均适用中华人民共和国法律（港澳台地区除外 ）。</p>
    <p>您与心潮科技公司或小睡眠移动客户端发生的一切争议，应友好协商，如协商不成的，可选择按下述任一途径解决：</p>
    <p>（一） 提交仲裁委员会，按照申请仲裁时现行有效的仲裁规则进行仲裁；仲裁裁决为终局裁决，对各方均有约束力；</p>
    <p>（二） 提交协议签订地人民法院诉讼管辖；<br/>
    请您再次确认您已全部阅读并充分理解上述条款 。</p>
    <p>注：本政策版本更新日期为2026年4月30日，如您认为更新的政策对您更为有利，我们同意双方适用新的政策内容。</p>
    <p style="text-align: right" class="strong">广州心与潮信息科技有限公司<br/>
      2026年4月30日</p>
    <p class="level2">附件一：《iOS版本小睡眠App涉及个人信息传输的SDK情况表》</p>
    <table>
      <thead>
        <tr>
          <th>序号</th>
          <th>SDK名称</th>
          <th>应用场景描述</th>
          <th>获取个人信息/权限</th>
          <th>第三方机构名称</th>
        </tr>
      </thead>
      <tbody>
          <tr>
            <td>1</td>
            <td>友盟+移动统计SDK</td>
            <td>提供统计分析服务，适用于App统计分析场景。</td>
            <td>唯一设备识别码、获取设备硬件序列号（如IMEI、Android ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID 信息）、位置信息、网络信息、获取应用列表</td>
            <td>友盟同欣（北京）科技有限公司</td>
          </tr>
          <tr>
            <td>2</td>
            <td>创蓝闪验SDK</td>
            <td>提供一键登录账号的服务</td>
            <td>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志、获取设备硬件序列号、获取本机号码、设备标识符（包括IDFV、OAID）、设备硬件信息（包括设备型号、设备硬件制造商）、操作系统信息（包括操作系统版本）、网络信息（包括网络类型、运营商名称、网络IP地址、网络状态、网络制式）、SIM卡信息（包括SIM卡状态、subId）、应用信息（包括BundleId、包名、包签名）。</td>
            <td>上海璟梦信息科技有限公司</td>
          </tr>
          <tr>
            <td>3</td>
            <td>七牛SDK</td>
            <td>提供音频文件下载完整性校验、以及用户账号头像上传的服务</td>
            <td>设备品牌、型号、操作系统版本、处理器信息、内存使用情况、IP 地址、网络类型及连接信息、读取设备外部存储空间、获取设备硬件序列号、获取 MAC 地址</td>
            <td>上海七牛信息技术有限公司</td>
          </tr>
          <tr>
            <td>4</td>
            <td>腾讯Bugly SDK</td>
            <td>提供崩溃日志上报、热修复、版本更新推送的服务</td>
            <td>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志、获取设备硬件序列号</td>
            <td>深圳市腾讯计算机系统有限公司</td>
          </tr>
          <tr>
            <td>5</td>
            <td>Google登录SDK</td>
            <td>提供登录第三方账号服务</td>
            <td>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号报错日志、获取设备硬件序列号</td>
            <td>Google公司</td>
          </tr>
          <tr>
            <td>6</td>
            <td>友盟分享SDK</td>
            <td>提供第三方账号登录与内容分享</td>
            <td>设备标志符，MAC地址，电话状态，网络状态，idfa，idfv，位置信息，唯一设备识别码、获取设备序列号（如IMEI、Android ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID 信息）、获取应用列表</td>
            <td>友盟同欣（北京）科技有限公司
</td>
          </tr>
          <tr>
            <td>7</td>
            <td>优量汇SDK</td>
            <td>提供广告展示的业务</td>
            <td>a. 设备信息：唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息；无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址；设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）；设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）、获取设备硬件序列号、读取OAID、读取设备IP
b. 应用信息：获取运行中进程信息、获取应用安装列表
c. 位置信息：精确位置信息、粗略位置信息、读取特定类型传感器列表</td>
            <td>深圳市腾讯计算机系统有限公司</td>
          </tr>
          <tr>
            <td>8</td>
            <td>穿山甲广告SDK</td>
            <td>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</td>
            <td>设备标识符（如IMEI、Android ID、OAID、IMSI、ICCID、GAID、MEID，设备序列号build_serial，IDFV、IDFA、ODID），设备MAC地址，IP地址，精确位置信息、粗略位置信息（WiFi列表、WLAN接入点（如SSID、BSSID）），设备传感器信息（加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器），设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间大小、手机系统重启时间、磁盘总空间、系统总内存空间、运营商信息、Wi-Fi状态、网络信号强度、软件列表、应用包名、运行中的进程信息、版本号、应用前后台状态、获取设备硬件序列号、获取Android ID</td>
            <td>北京巨量引擎网络技术有限公司</td>
          </tr>
          <tr>
            <td>9</td>
            <td>京准通SDK</td>
            <td>提供广告展示的业务</td>
            <td>a. 设备信息：唯一设备识别码（IMEI/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息；无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址；设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）；设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）、获取设备硬件序列号
b. 应用信息：获取运行中进程信息、获取应用安装列表
c. 位置信息：精确位置信息、粗略位置信息
</td>
            <td>北京京东世纪贸易有限公司</td>
          </tr>
          <tr>
            <td>10</td>
            <td>日志服务（SLS）SDK</td>
            <td>提供统计分析服务</td>
            <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取 MAC 地址
</td>
            <td>阿里云计算有限公司</td>
          </tr>
          <tr>
            <td>11</td>
            <td>蒂烨 SDK</td>
            <td>提供广告展示的业务</td>
            <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取 MAC 地址
</td>
            <td>蒂烨大数据科技（广州）有限公司</td>
          </tr>
          <tr>
            <td>12</td>
            <td>MMA 中国广告监测通用SDK</td>
            <td>提供广告展示的业务</td>
            <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取 MAC 地址
</td>
            <td>上海亦拓广告有限公司</td>
          </tr>
          <tr>
            <td>13</td>
            <td>创智汇聚 SDK（Sigmob SDK）</td>
            <td>提供广告展示的业务</td>
            <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取 MAC 地址
</td>
            <td>北京创智汇聚科技有限公司</td>
          </tr>
          <tr>
            <td>14</td>
            <td>快手联盟 SDK</td>
            <td>提供广告展示的业务</td>
            <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取 MAC 地址
</td>
            <td>北京快手广告有限公司</td>
          </tr>
          <tr>
            <td>15</td>
            <td>com.heartide</td>
            <td>提供复制粘贴业务</td>
            <td>获取粘贴板信息</td>
            <td>广州心与潮信息科技有限公司</td>
          </tr>
          <tr>
            <td>16</td>
            <td>新浪微博移动SDK</td>
            <td>提供微博账号登录、分享内容至微博平台的服务</td>
            <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址、 读取WIFI的SSID、读取WIFI的BSSID</td>
            <td>北京微梦创科网络技术有限公司</td>
          </tr>
          <tr>
            <td>17</td>
            <td>号码认证</td>
            <td>识别⽤户的⼿机号码快速登录/号码校验，问题查询、分析、风险控制</td>
            <td>
              网络类型、网络地址、运营商类型、本机号码、SIM卡状态、手机设备类型、手机操作系统、硬件厂商
            </td>
            <td>中移互联网有限公司</td>
          </tr>
          <tr>
            <td>18</td>
            <td>联通认证SDK</td>
            <td>识别⽤户的⼿机号码快速登录/号码校验</td>
            <td>
              网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商
            </td>
            <td>联通在线信息科技有限公司
            </td>
          </tr>
          <tr>
            <td>19</td>
            <td>天翼账号认证SDK</td>
            <td>识别⽤户的⼿机号码快速登录/号码校验及业务风控</td>
            <td>
              注册手机号码、本机号码、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本
            </td>
            <td>天翼数字生活科技有限公司
            </td>
          </tr>

      </tbody>
    </table>
    <p class="level2">附件二：《Android版本小睡眠App涉及个人信息传输的SDK情况表》</p>

    <table>
      <thead>
      <tr>
        <th>序号</th>
        <th>SDK名称</th>
        <th>应用场景描述</th>
        <th>获取个人信息/权限</th>
        <th>第三方机构名称</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>1</td>
        <td>友盟+移动统计SDK</td>
        <td>提供统计分析服务，适用于App统计分析场景。</td>
        <td>设备标志符，MAC地址，电话状态，网络状态，idfa，idfv，位置信息，唯一设备识别码、获取设备硬件序列号（如IMEI、Android ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID 信息）、获取应用列表</td>
        <td>友盟同欣（北京）科技有限公司</td>
      </tr>
      <tr>
        <td>2</td>
        <td>创蓝闪验SDK</td>
        <td>提供一键登录账号的服务</td>
        <td>
          获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志、获取设备硬件序列号、获取Android ID、获取本机号码、设备标识符（包括IDFV、OAID）、设备硬件信息（包括设备型号、设备硬件制造商）、操作系统信息（包括操作系统版本）、网络信息（包括网络类型、运营商名称、网络IP地址、网络状态、网络制式）、SIM卡信息（包括SIM卡状态、subId）、应用信息（包括BundleId、包名、包签名）。
        </td>
        <td>上海璟梦信息科技有限公司</td>
      </tr>
      <tr>
        <td>3</td>
        <td>七牛SDK</td>
        <td>提供音频文件下载完整性校验、以及用户账号头像上传的服务</td>
        <td>设备品牌、型号、操作系统版本、处理器信息、内存使用情况、IP 地址、网络类型及连接信息、读取设备外部存储空间、获取设备硬件序列号、获取 MAC 地址</td>
        <td>上海七牛信息技术有限公司</td>
      </tr>
      <tr>
        <td>4</td>
        <td>腾讯Bugly SDK</td>
        <td>提供崩溃日志上报、热修复、版本更新推送的服务</td>
        <td>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志、获取设备硬件序列号、获取Android ID</td>
        <td>深圳市腾讯计算机系统有限公司</td>
      </tr>
      <tr>
        <td>5</td>
        <td>Google登录SDK</td>
        <td>提供登录第三方账号服务</td>
        <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
        <td>Google公司</td>
      </tr>
      <tr>
        <td>6</td>
        <td>友盟分享SDK</td>
        <td>提供第三方账号登录与内容分享</td>
        <td>设备标志符，MAC地址，电话状态，网络状态，idfa，idfv，位置信息，唯一设备识别码、获取设备序列号（如IMEI、Android ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID 信息）、获取应用列表</td>
        <td>友盟同欣（北京）科技有限公司</td>
      </tr>
      <tr>
        <td>7</td>
        <td>优量汇SDK</td>
        <td>提供广告展示的业务</td>
        <td>设备信息，应用信息，位置信息，设备标识符，WiFi地址 无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址 设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异） 设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）、获取设备硬件序列号、获取Android ID、读取OAID、读取特定类型传感器列表、读取设备IP </td>
        <td>深圳市腾讯计算机系统有限公司</td>
      </tr>
      <tr>
        <td>8</td>
        <td>穿山甲广告SDK</td>
        <td>广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</td>
        <td>设备标识符（如IMEI、Android ID、OAID、IMSI、ICCID、GAID、MEID，设备序列号build_serial，IDFV、IDFA、ODID），设备MAC地址，IP地址，精确位置信息、粗略位置信息（WiFi列表、WLAN接入点（如SSID、BSSID）），设备传感器信息（加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器），设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间大小、手机系统重启时间、磁盘总空间、系统总内存空间、运营商信息、Wi-Fi状态、网络信号强度、软件列表、应用包名、运行中的进程信息、版本号、应用前后台状态、获取设备硬件序列号、获取Android ID</td>
        <td>北京巨量引擎网络技术有限公司</td>
      </tr>
      <tr>
        <td>9</td>
        <td>京准通SDK</td>
        <td>提供广告展示的业务</td>
        <td>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号报错日志、获取设备硬件序列号、获取Android ID</td>
        <td>北京京东世纪贸易有限公司</td>
      </tr>
      <tr>
        <td>10</td>
        <td>日志服务（SLS）SDK</td>
        <td>提供统计分析服务</td>
        <td>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号报错日志、获取设备硬件序列号、获取Android ID </td>
        <td>阿里云计算有限公司</td>
      </tr>
      <tr>
        <td>11</td>
        <td>FileDownloader SDK</td>
        <td>提供音频文件下载保存的服务</td>
        <td>读取您的设备外部存储空间、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
        <td>开源项目</td>
      </tr>
      <tr>
        <td>12</td>
        <td>takephoto_library SDK</td>
        <td>提供账号头像图片裁剪的服务</td>
        <td>读取您的设备外部存储空间、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
        <td>开源项目</td>
      </tr>
      <tr>
        <td>13</td>
        <td>微信支付SDK</td>
        <td>提供微信支付服务
a.保障用户账户和资金安全以及支付服务的安全稳定运行。
b.履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。
c.实现网络链路的选择和优化，以提升用户体验。</td>
        <td>Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表；开放匿名设备标识符、MAC地址、IMEI信息、传感器、设备硬件序列号</td>
        <td>深圳市腾讯计算机系统有限公司</td>
      </tr>
      <tr>
        <td>14</td>
        <td>支付宝客户端SDK</td>
        <td>提供支付宝支付服务
a.保障用户账户和资金安全以及支付服务的安全稳定运行。
b.履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。
c.实现网络链路的选择和优化，以提升用户体验。
</td>
        <td>Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表；开放匿名设备标识符、MAC地址、IMEI信息、传感器、设备硬件序列号
</td>
        <td>支付宝（中国）网络技术有限公司</td>
      </tr>
      <tr>
        <td>15</td>
        <td>魅族推送SDK</td>
        <td>提供消息通知的服务</td>
        <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
        <td>珠海市魅网科技有限公司</td>
      </tr>
      <tr>
        <td>16</td>
        <td>华为推送SDK</td>
        <td>提供消息通知的服务</td>
        <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
        <td>华为技术有限公司</td>
      </tr>
      <tr>
        <td>17</td>
        <td>小米推送SDK</td>
        <td>提供消息通知的服务</td>
        <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
        <td>北京小米科技有限公司</td>
      </tr>
      <tr>
        <td>18</td>
        <td>OPPO推送SDK</td>
        <td>提供消息通知的服务</td>
        <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
        <td>OPPO广东移动通信有限公司</td>
      </tr>
      <tr>
        <td>19</td>
        <td>vivo推送SDK</td>
        <td>提供消息通知的服务</td>
        <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
        <td>维沃移动通信有限公司</td>
      </tr>
      <tr>
        <td>20</td>
        <td>Zxing二维码扫描SDK</td>
        <td>仅用于内部调试，不对外开放</td>
        <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址 </td>
        <td>Google公司 </td>
      </tr>
      <tr>
        <td>21</td>
        <td>Glide SDK</td>
        <td>提供加载图片内容的服务</td>
        <td>读取设备IP、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
        <td>开源项目</td>
      </tr>
      <tr>
        <td>22</td>
        <td>OkHttp SDK</td>
        <td>以提供网络请求的服务</td>
        <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
        <td>开源项目</td>
      </tr>
      <tr>
        <td>23</td>
        <td>RxJava SDK</td>
        <td>提供响应式编程框架基础服务</td>
        <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
        <td>开源项目</td>
      </tr>
      <tr>
        <td>24</td>
        <td>OPPO Watch SDK</td>
        <td>提供OPPO手表与手机连接服务</td>
        <td>蓝牙状态、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
        <td>OPPO广东移动通信有限公司</td>
      </tr>
      <tr>
        <td>25</td>
        <td>魅族联运SDK</td>
        <td>提供应用内支付购买的服务</td>
        <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
        <td>魅族科技有限公司</td>
      </tr>
      <tr>
        <td>26</td>
        <td>华为联运应用SDK（Android版）</td>
        <td>提供应用内支付购买的服务</td>
        <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
        <td>华为技术有限公司</td>
      </tr>
      <tr>
        <td>27</td>
        <td>小米联运SDK</td>
        <td>提供应用内支付购买的服务</td>
        <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
        <td>北京小米科技有限公司</td>
      </tr>
      <tr>
        <td>28</td>
        <td>OPPO联运SDK</td>
        <td>提供应用内支付购买的服务</td>
        <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
        <td>OPPO广东移动通信有限公司</td>
      </tr>
      <tr>
        <td>29</td>
        <td>vivo联运SDK</td>
        <td>提供应用内支付购买的服务</td>
        <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
        <td>维沃移动通信有限公司</td>
      </tr>

      <tr>
      <td>30</td>
      <td> 移动智能终端补充设备标识体系SDK</td>
      <td> 访问移动智能终端补充设备标识体系</td>
      <td> 设备标识符、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 中国信息通信研究院</td>
      </tr>

      <tr>
      <td> 31</td>
      <td> AndroidGifDrawable SDK</td>
      <td> 显示动画gif组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 32</td>
      <td> SpringFramework SDK</td>
      <td> 基础架构组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 33</td>
      <td> ReactiveStreams SDK</td>
      <td> 加载响应组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 34</td>
      <td> Sanselan SDK</td>
      <td> 图片处理组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> ApacheSoftware公司</td>
      </tr>

      <tr>
      <td> 35</td>
      <td> ApacheHttp SDK</td>
      <td> HTTP和相关协议的底层框架</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 36</td>
      <td> Okio SDK</td>
      <td> 基础架构组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 37</td>
      <td> Okhttp3 SDK</td>
      <td> HTTP和相关协议的底层框架</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> Square公司</td>
      </tr>

      <tr>
      <td> 38</td>
      <td> OauthSignpost SDK</td>
      <td> 基础架构组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 39</td>
      <td> MagicIndicator SDK</td>
      <td> 基础架构组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 40</td>
      <td> Blurry SDK</td>
      <td> 基础架构组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 41</td>
      <td> Realm SDK</td>
      <td> 基础架构组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 42</td>
      <td> RxJava-2 SDK</td>
      <td> 加载响应组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> ReactiveX公司</td>
      </tr>

      <tr>
      <td> 43</td>
      <td> GridViewwithHeaderandFooter SDK</td>
      <td> 基础架构组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 44</td>
      <td> YouthBanner SDK</td>
      <td> 图片轮播组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 45</td>
      <td> WheelView SDK</td>
      <td> 滚轮控件组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 46</td>
      <td> ViewPagerIndicator SDK</td>
      <td> 指示器组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 47</td>
      <td> 微信开放平台 SDK</td>
      <td> 微信分享、登录、收藏、支付功能</td>
      <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 深圳市腾讯计算机系统有限公司</td>
      </tr>

      <tr>
      <td> 48</td>
      <td> QQ登录 SDK</td>
      <td> 用户使用QQ账号登录应用</td>
      <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 深圳市腾讯计算机系统有限公司</td>
      </tr>

      <tr>
      <td> 49</td>
      <td> 腾讯地图定位 SDK</td>
      <td> 提供腾讯地图定位服务</td>
      <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 深圳市腾讯计算机系统有限公司</td>
      </tr>

      <tr>
      <td> 50</td>
      <td> 腾讯浏览服务 SDK</td>
      <td> 优化移动端webview体验</td>
      <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 深圳市腾讯计算机系统有限公司</td>
      </tr>


      <tr>
      <td> 51</td>
      <td> RxPermissions SDK</td>
      <td> 基础架构组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 52</td>
      <td> Otto SDK</td>
      <td> 基础架构组件</td>
      <td>获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>


      <tr>
      <td> 53</td>
      <td> AndroidCrop SDK</td>
      <td> 图像裁剪组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 54</td>
      <td> 新浪微博移动SDK</td>
      <td> 提供微博分享功能</td>
      <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址、读取WIFI的SSID
      </td>
      <td> 北京微梦创科网络技术有限公司</td>
      </tr>

      <tr>
      <td> 55</td>
      <td> 微博账号登录 SDK</td>
      <td> 使用微博账号登录</td>
      <td> 设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
      <td> 北京微梦创科网络技术有限公司</td>
      </tr>

      <tr>
      <td> 56</td>
      <td> 联通登录 SDK</td>
      <td> 提供WO+通行证（统一登录账号）服务</td>
      <td> 设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
      <td> 中国联合网络通信集团有限公司</td>
      </tr>


      <tr>
      <td> 57</td>
      <td> SmartRefreshLayout SDK</td>
      <td> 基础架构组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 58</td>
      <td> OAID_SAMSUNG SDK</td>
      <td> 获取设备标识组件</td>
      <td> 设备标识符、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 中国信息通信研究院</td>
      </tr>

      <tr>
      <td> 59</td>
      <td> OAID_ZUI SDK</td>
      <td> 获取设备标识组件</td>
      <td> 设备标识符、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 中国信息通信研究院</td>
      </tr>

      <tr>
      <td> 60</td>
      <td> Leonids SDK</td>
      <td> 基础工具组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>


      <tr>
      <td> 61</td>
      <td> UniversalImageLoader SDK</td>
      <td> 图像加载组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 62</td>
      <td> SwipeDelMenuLayout SDK</td>
      <td> 侧滑菜单组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 63</td>
      <td> TimePickerDialog SDK</td>
      <td> 时间选择组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 64</td>
      <td> OAID_HUAWEI SDK</td>
      <td> 获取设备标识组件</td>
      <td> 设备标识符、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 中国信息通信研究院</td>
      </tr>
      <tr>
      <td> 65</td>
      <td> 华为应用内支付 SDK</td>
      <td>集成华为帐号与支付功能</td>
      <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、交易信息、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 华为技术有限公司</td>
      </tr>
      <tr>
      <td> 66</td>
      <td> 华为更新 SDK</td>
      <td> 华为自升级服务</td>
      <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 华为技术有限公司</td>
      </tr>
      <tr>
      <td> 67</td>
      <td> HMSSdkIAP SDK</td>
      <td> 华为服务基础组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 华为技术有限公司</td>
      </tr>
      <tr>
      <td> 68</td>
      <td> HuaweiHiAnalytics SDK</td>
      <td> 华为数据组件</td>
      <td> 设备标识符，网络状态、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 华为技术有限公司</td>
      </tr>
      <tr>
      <td> 69</td>
      <td> 华为HMS SDK</td>
      <td> 华为HMS更新服务</td>
      <td> 设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
      <td> 华为技术有限公司</td>
      </tr>
      <tr>
      <td> 70</td>
      <td> Cardboard SDK</td>
      <td> 虚拟现实(VR)工具组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 71</td>
      <td> ExoPlayer SDK</td>
      <td> 媒体播放器组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> Google公司</td>
      </tr>


      <tr>
      <td> 72</td>
      <td> 谷歌Gson SDK</td>
      <td> 基础架构组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> Google公司</td>
      </tr>

      <tr>
      <td> 73</td>
      <td> Google Protobuf SDK</td>
      <td> 序列化框架组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> Google公司</td>
      </tr>

      <tr>
      <td> 74</td>
      <td> SpinKit SDK</td>
      <td> 动画加载组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 75</td>
      <td> ReLinker SDK</td>
      <td> 基础架构组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> Keepsafe公司</td>
      </tr>

      <tr>
      <td> 76</td>
      <td> FlycoDialog SDK</td>
      <td> 对话框组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 77</td>
      <td> Shimmer SDK</td>
      <td> 基础架构组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 78</td>
      <td> MultipleImageSelect SDK</td>
      <td> 图片选择组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 79</td>
      <td> AndroidVideoCache SDK</td>
      <td> 视频缓存组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 80</td>
      <td> 移动授权登录 SDK</td>
      <td> 提供一键登录账号服务</td>
      <td> 设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
      <td> 中移互联网有限公司</td>
      </tr>

      <tr>
      <td> 81</td>
      <td> BigkooPickerview SDK</td>
      <td> 时间选择器组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 深圳必酷科技有限公司</td>
      </tr>

      <tr>
      <td> 82</td>
      <td> OAID_ASUS SDK</td>
      <td> 获取设备标识组件</td>
      <td> 设备标识符、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 中国信息通信研究院</td>
      </tr>

      <tr>
      <td> 83</td>
      <td> 支付宝安全 SDK</td>
      <td> 蚂蚁金服提供的安全插件</td>
      <td> 设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
      <td> 蚂蚁金服（杭州）网络技术有限公司</td>
      </tr>

      <tr>
      <td> 84</td>
      <td> 支付宝客户端支付安全 SDK</td>
      <td> 蚂蚁金服提供的安全插件</td>
      <td> 设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
      <td> 蚂蚁金服（杭州）网络技术有限公司</td>
      </tr>

      <tr>
      <td> 85</td>
      <td> AliFastJson SDK</td>
      <td> 基础架构组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 杭州阿里巴巴广告有限公司</td>
      </tr>

      <tr>
      <td> 86</td>
      <td> 阿里ARouter SDK</td>
      <td> 基础架构组件</td>
      <td> 设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
      <td> 阿里云计算有限公司</td>
      </tr>

      <tr>
      <td> 87</td>
      <td> 阿里百川组件 SDK</td>
      <td> 数据分析组件</td>
      <td> 设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 阿里云计算有限公司</td>
      </tr>

      <tr>
      <td> 88</td>
      <td> AirbnbLottie SDK</td>
      <td> 基础架构组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 89</td>
      <td> AndroidSMS SDK</td>
      <td> 短信验证码工具</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 上海游昆信息技术有限公司</td>
      </tr>

      <tr>
      <td> 90</td>
      <td> Kpswitch SDK</td>
      <td> 键盘面板组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
      <td> 91</td>
      <td> 中国电信 SDK</td>
      <td> 登录账号功能</td>
      <td> 设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
      <td> 中国电信集团有限公司</td>
      </tr>


      <tr>
      <td> 92</td>
      <td> 京东选择器 SDK</td>
      <td> 地址选择组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 北京京东叁佰陆拾度电子商务有限公司</td>
      </tr>

      <tr>
      <td> 93</td>
      <td> ButterKnife SDK</td>
      <td> 视图布局组件</td>
      <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
      <td> 开源项目</td>
      </tr>

      <tr>
        <td> 94</td>
        <td> 蒂烨 SDK</td>
        <td> 提供广告展示的业务</td>
        <td> 设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
        <td> 蒂烨大数据科技（广州）有限公司</td>
      </tr>
      <tr>
        <td> 95</td>
        <td> Facebook 登录 SDK</td>
        <td> 提供登录第三方账号服务</td>
        <td> 获取设备硬件序列号、获取Android ID、获取 MAC 地址</td>
        <td> Facebook 公司</td>
      </tr>
          <tr>
            <td>96</td>
            <td>MMA 中国广告监测通用SDK</td>
            <td>提供广告展示的业务</td>
            <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
            <td>上海亦拓广告有限公司</td>
          </tr>
          <tr>
            <td>97</td>
            <td>创智汇聚 SDK（Sigmob SDK）</td>
            <td>提供广告展示的业务</td>
            <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
            <td>北京创智汇聚科技有限公司</td>
          </tr>
          <tr>
            <td>98</td>
            <td>快手联盟 SDK</td>
            <td>提供广告展示的业务</td>
            <td>设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、获取设备硬件序列号、获取Android ID、获取 MAC 地址
</td>
            <td>北京快手广告有限公司</td>
          </tr>
          <tr>
            <td>99</td>
            <td>com.heartide</td>
            <td>提供复制粘贴业务</td>
            <td>获取粘贴板信息</td>
            <td>广州心与潮信息科技有限公司</td>
          </tr>
          <tr>
            <td>100</td>
            <td>图灵盾风险识别SDK</td>
            <td>及反作弊场景统计，如虚假流量识别等</td>
            <td>硬件序列号、网络状态、系统设置、系统属性、设备型号、操作系统、IP地址、运营商信息、标识符如OAID、IDFA、IDFV等 由第三方开发者根据实际情况决定是否采集并传输给SDK，SDK采取去标识、加密等方式进行处理 </td>
            <td>深圳市腾讯计算机系统有限公司</td>
          </tr>
          <tr>
            <td>101</td>
            <td>Qone SDK</td>
            <td>广告归因，识别黑产和虚假设备 </td>
            <td>IP地址、设备型号、设备标识信息（OAID、Android ID、IDFA、IDFV等）</td>
            <td>深圳市腾讯计算机系统有限公司</td>
          </tr>
          <tr>
            <td>102</td>
            <td>倍孜SDK</td>
            <td>广告投放、广告归因、广告反作弊。</td>
            <td>
                设备标识符（如IMEI、Android ID、OAID、IMSI、ICCID、GAID、MEID，设备序列号build_serial，IDFV、IDFA、ODID），设备MAC地址，IP地址，精确位置信息、粗略位置信息（WiFi列表、WLAN接入点（如SSID、BSSID）），设备传感器信息（加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器），设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间大小、手机系统重启时间、磁盘总空间、系统总内存空间、运营商信息、Wi-Fi状态、网络信号强度、软件列表、应用包名、运行中的进程信息、版本号、应用前后台状态、获取设备硬件序列号、获取Android ID
              【Android+iOS+HarmonyOS】设备品牌、设备型号、设备时区、设备语言、系统版本、UserAgent信息、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、磁盘空间、物理内存、网络类型、运营商、开发者应用名、应用版本号、应用包名、产品交互数据、广告数据(展示、点击、转化)、崩溃数据、性能数据、粗略位置信息、加速度传感器、陀螺仪
              【Android+iOS】系统更新时间、精确位置信息、重力传感器、方向传感器、压力传感器、线性加速度传感器
              【Android+HarmonyOS】OAID
              【iOS+HarmonyOS】设备名称
              【仅Android】cpu、sim卡状态、运行状态
              【仅iOS】开机时间、IDFA、IDFV、磁力传感器</td>
            <td>上海倍孜网络技术有限公司 </td>
          </tr>
          <tr>
            <td>103</td>
            <td>号码认证</td>
            <td>识别⽤户的⼿机号码快速登录/号码校验，问题查询、分析、风险控制
            </td>
            <td>网络类型、网络地址、运营商类型、本机号码、SIM卡状态、手机设备类型、手机操作系统、硬件厂商
            </td>
            <td>中移互联网有限公司
            </td>
          </tr>
          <tr>
            <td>104</td>
            <td>联通认证SDK
            </td>
            <td>识别⽤户的⼿机号码快速登录/号码校验
            </td>
            <td>网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商
            </td>
            <td>联通在线信息科技有限公司
            </td>
          </tr>
          <tr>
            <td>105</td>
            <td>天翼账号认证SDK
            </td>
            <td>识别⽤户的⼿机号码快速登录/号码校验及业务风控
            </td>
            <td>注册手机号码、本机号码、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本
            </td>
            <td>天翼数字生活科技有限公司
            </td>
          </tr>
          <tr>
            <td>106</td>
            <td>AdScope SDK Android
            </td>
            <td>广告投放、广告归因、广告反作弊。
            </td>
            <td>必选信息：
                设备标识符（如IMEI、Android ID、OAID、IMSI、ICCID、GAID、MEID，设备序列号build_serial，IDFV、IDFA、ODID），设备MAC地址，IP地址，精确位置信息、粗略位置信息（WiFi列表、WLAN接入点（如SSID、BSSID）），设备传感器信息（加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器），设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间大小、手机系统重启时间、磁盘总空间、系统总内存空间、运营商信息、Wi-Fi状态、网络信号强度、软件列表、应用包名、运行中的进程信息、版本号、应用前后台状态、获取设备硬件序列号、获取Android ID
              【双端】设备品牌、设备型号、设备时区、设备语言、系统版本、UserAgent信息、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、磁盘空间、物理内存、网络类型、运营商、开发者应用名、应用版本号、应用包名、交互数据、广告数据(展示、点击、转化)、崩溃数据、性能数据
              【iOS】开机时间、设备名称
              【Android】OAID、sim卡状态、cpu、运行状态
              可选信息：
              【双端】精确位置信息、粗略位置信息、重力传感器、加速度传感器、方向传感器、陀螺仪、压力传感器、线性加速度传感器
              【iOS】IDFA、IDFV、磁力传感器
            </td>
            <td>上海倍孜网络技术有限公司
            </td>
          </tr>
      </tbody>
    </table>
    <p class="level2">附件三：《iOS 版本功能使用所需权限列表》</p>
    <table>
      <thead>
      <tr>
        <th>小睡眠功能</th>
        <th>功能说明</th>
        <th>权限使用说明</th>
      </tr>
      </thead>
      <tbody >
        <tr>
          <td>个人头像</td>
          <td>为用户提供设置、更换头像的功能。</td>
          <td>允许App使用摄像头并访问相册、图片内容</td>
        </tr>
        <tr>
          <td>宁静空间</td>
          <td>为用户提供分析环境噪音，推荐遮蔽噪音的功能。</td>
          <td>允许程序通过手机或耳机的麦克风录制声音</td>
        </tr>
        <tr>
          <td>记录睡眠</td>
          <td>为用户提供分析睡眠质量，记录梦话鼾声的功能。</td>
          <td>允许程序通过手机或耳机的麦克风录制声音</td>
        </tr>
        <tr>
          <td>小实验室</td>
          <td>为用户提供分析心率变化，推荐放松白噪音的功能。</td>
          <td>允许程序访问摄像头进行拍照</td>
        </tr>
      </tbody>
    </table>
    <p class="level2">附件四：《Android 版本功能使用所需权限列表》</p>
    <table>
      <thead>
      <tr>
        <th>小睡眠功能</th>
        <th>功能说明</th>
        <th>权限使用说明</th>
      </tr>
      </thead>
      <tbody >
      <tr>
        <td>个人头像</td>
        <td>为用户提供设置、更换头像的功能。</td>
        <td>允许App使用摄像头并访问相册、图片内容</td>
      </tr>
      <tr>
        <td>宁静空间</td>
        <td>为用户提供分析环境噪音，推荐遮蔽噪音的功能。</td>
        <td>允许程序通过手机或耳机的麦克风录制声音</td>
      </tr>
      <tr>
        <td>记录睡眠</td>
        <td>为用户提供分析睡眠质量，记录梦话鼾声的功能。</td>
        <td>允许程序通过手机或耳机的麦克风录制声音</td>
      </tr>
      <tr>
        <td>小实验室</td>
        <td>为用户提供分析心率变化，推荐放松白噪音的功能。</td>
        <td>允许程序访问摄像头进行拍照</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'privacy',
  data() {
    return {}
  },
  created() {
    document.getElementsByTagName("title")[0].innerHTML="&#65279;"
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.privacy {
  font-size: 16px;
  text-align: left;
  padding: 15px 15px 200px 15px;
  width: 100%;
  box-sizing:border-box;
}

.title {
  text-align: center;
  margin: 50px 0;
  display: block;
  font-size: 20px;
  font-weight: bold;
}

.level1 {
  font-size: 20px;
  font-weight: bold;
  margin: 30px 0;
}

.level2, .level3 {
  font-size: 20px;
  font-weight: bold;
  margin: 30px 0;
}

.level4 {
  font-size: 20px;
  margin: 30px 0;
}
p {
  font-size: 16px;
  margin: 25px 0;
  word-break: break-word;
}
.strong {
  font-weight: 700;
}
table{
  border-collapse:collapse;
  table-layout:fixed;
  width: 100%;
  th{
    font-weight: 700;
    border:1px solid black;
    background-color: #E6EBF0;
    padding: 5px;
  }
  td{
    border:1px solid black;
    padding: 5px;
    overflow-wrap: break-word;
  }
}
</style>

